import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Divider, IconButton, TextareaAutosize, Tooltip } from "@mui/material";
import { format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import Box from "@mui/material/Box";
import { CiSquarePlus } from "react-icons/ci";
import { CiEdit } from "react-icons/ci";

import { GoHistory } from "react-icons/go";
import { RxReset } from "react-icons/rx";

import Modal from "@mui/material/Modal";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  DeleteIcon,
  EditIcon,
  EmrPatholgyIcon,
  EmrRadiologyIcon,
  ForceCloseIcon,
  PrescriptionIcon,
  TemplateIcon,
} from "../../../assets/CommonAssets";
import AdviceTemplateModal from "./AdviceTemplateModal";
import ClinicalModal from "./ClinicalModal";
import ComplaintsModal from "./ComplaintsModal";
import CustomCreateable from "./CustomCreateable";
import DiagnosisModal from "./DiagnosisModal";
import InvestigationModal from "./InvestigationsModal";
import LocalAdvicesModal from "./LocalAdvicesModal";
import MedicinesTable from "./MedicinesTable";
import OtherServicesModal from "./OtherServicesModal";
import PastHistoryModal from "./PastHistoryModal";
import PrintOptions from "./PrintOptions";
import {
  getFrequencyForDrugOrder,
  getCommonRoutes,
  getGeneralFrequencies,
  getGenericDrugs,
  getInvestigations,
  getMedicationInstructions,
  getMedicines,
  getDiagnosis,
  getReferenceDoctor,
  getDrugForm,
  saveEmrLite,
  getPatientEmrDetails,
  getPrevEmrList,
  getAdviceData,
  getOtherServices,
  getComplaintsData,
  getAllergiesData,
  getMedicinesByDoctorItemId,
} from "./Services";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import InputField from "../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import AllergyModal from "./AllergyModal";
import FamilyHistoryModal from "./FamilyHistoryModal";
import OtherReferralModal from "./OtherReferralModal";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import {
  emrTemplateEditData,
  emrTemplateList,
  getAdviceDropDownData,
  getCommonPastHistoryList,
  getPastHistoryAutoSearch,
  getTemplateSuggetion,
  saveTemplateMaster,
} from "../../services/emrTemplateServices/EMRTemplateServices";
import {
  getPatientEmrPatch,
  saveEMR,
  updateEMR,
  getPatientLastMedications,
  startEMRConsultation,
} from "../../services/emrServices/EMRServices";
import EMRPrescriptionPrint from "../../prints/EMRPrescriptionPrint";
import { FaHistory } from "react-icons/fa";
import OldMedicationModal from "./OldMedicationModal";
import LIMSIcon from "../../../nursingStation/components/clinicalcarechart/assets/LIMSIcon";
import EMRInvestigationsModal from "./EMRInvestigationsModal";
import InputArea from "../../../common/components/FormFields/InputArea";
import TableDropDownField from "../../../common/components/FormFields/TableDropDownField";
import InputAreaDropdown from "../../../common/components/FormFields/InputAreaDropdown";
import TemplateNameModal from "./TemplateNameModal";
import SystematicExamModal from "./systemicexamination/SystematicExamModal";
import NewTemplateModal from "./systemicexamination/NewTemplateModal";
import AdvicesTemplate from "../emrTemplate/AdvicesTemplate";
import DietExerciseModal from "../emrTemplate/DietExerciseModal";
import GeneralExamTemplate from "../emrTemplate/GeneralExamTemplate";
import PastHistoryTemplateModal from "../emrTemplate/PastHistoryTemplateModal";
import FamilyHistoryTemplateModal from "../emrTemplate/FamilyHistoryTemplateModal";
import ComplaintsTemplateModal from "../emrTemplate/ComplaintsTemplateModal";
import AllergyTemplateModal from "../emrTemplate/AllergyTemplateModal";

const medicinesData = [
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
];
const iconButtonStyle = {
  width: 26,
  height: 26,
  p: 0.5,
  color: "#fff",
  borderRadius: "50%",
};
const templateData = [
  { label: "Pain Relief", value: "pain_relief" },
  { label: "Antibiotic", value: "antibiotic" },
  { label: "Vitamins & Supplements", value: "vitamins_supplements" },
  { label: "Cold & Flu", value: "cold_flu" },
  { label: "Allergy Medication", value: "allergy_medication" },
  { label: "Digestive Health", value: "digestive_health" },
];

const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "98%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  overflowY: "auto",
  borderRadius: 3,
  p: 1,
};

let templateobjdata = [
  {
    id: 1000,
    label: "Pediatrics Template",
    value: "Pediatrics Template",
  },
  {
    id: 8,
    label: "Pediatrics Template",
    value: "Pediatrics Template",
  },
  {
    id: 8,
    label: "Pediatrics Template",
    value: "Pediatrics Template",
  },
  {
    id: 8,
    label: "Pediatrics Template",
    value: "Pediatrics Template",
  },
  {
    id: 8,
    label: "Pediatrics Template",
    value: "Pediatrics Template",
  },
  {
    id: 8,
    label: "Pediatrics Template",
    value: "Pediatrics Template",
  },
];

function EmrLiteNew(props) {
  const { openEmrModal, close, selectedRow, setOpenEMrBackdrop } = props;
  let token = JSON.parse(localStorage.getItem("userInfo"));
  const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
  const location = useLocation();
  const navigate = useNavigate();
  const complaintFocusRef = useRef();
  const allergyFocusRef = useRef();
  const investigationFocusRef = useRef();
  const diagnosisFocusRef = useRef();
  const advicesFocusRef = useRef();
  const otherReferralFocusRef = useRef();
  const otherServicesFocusRef = useRef();

  const [openPastHistory, setOpenPastHistory] = React.useState(false);
  const [impNotes, setImpNotes] = React.useState("");
  const [openFamilyHistory, setOpenFamilyHistory] = React.useState(false);
  const [invOptions, setInvOptions] = React.useState([]);
  const [diagnoOptions, setDiagnoOptions] = React.useState([]);
  const [advicesOptions, setAdvicesOptions] = React.useState([]);
  const [dietOptions, setDietOptions] = React.useState([]);
  const [postObject, setPostObject] = React.useState(null);
  const [openPost, setOpenPost] = React.useState(false);
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [genericDrugs, setGenericDrugs] = React.useState([]);
  const [medicineInstructions, setMedicineInstructions] = React.useState([]);
  const [selectedHistoryIndex, setSelectedHistoryIndex] = React.useState([]);
  const [selectedFamilyHistoryIndex, setSelectedFamilyHistoryIndex] =
    React.useState([]);
  const [complaints, setComplaints] = React.useState([]);
  const [selectedComplaints, setSelectedComplaints] = React.useState([]);
  const [resetCount, setResetCount] = React.useState(0);
  const [openComplaints, setOpenComplaints] = React.useState(false);
  const [resetComplaints, setResetComplaints] = React.useState(0);
  const [resetDiagnosis, setResetDiagnosis] = React.useState(0);
  const [diagnosis, setDiagnosis] = React.useState([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = React.useState([]);
  const [selectedAllergy, setSelectedAllergy] = React.useState([]);
  const [selectedOtherReferral, setSelectedOtherReferral] = React.useState([]);
  const [openDiagnosis, setOpenDiagnosis] = React.useState(false);
  const [openInvestigation, setOpenInvestigation] = React.useState(false);
  const [investigationList, setInvestigationList] = React.useState([]);
  const [searchMedicines, setSearchMedicines] = React.useState([]);
  const [frequencyOptions, setFrequencyOptions] = React.useState([]);
  const [routes, setRoutes] = React.useState([]);
  const [openServices, setOpenServices] = React.useState(false);
  const [otherServices, setOtherServices] = React.useState([]);
  const [resetServices, setResetServices] = React.useState(0);
  const [lastVisits, setLastVisits] = React.useState([]);
  const [visitIndex, setVisitIndex] = React.useState(null);
  const [selectedVisitRow, setSelectedVisitRow] = React.useState(null);
  const [openAdviceTemplate, setOpenAdviceTemplate] = React.useState(false);
  const [openPathologyReport, setOpenPathologyReport] = React.useState(false);
  const [adviceTemplates, setAdviceTemplates] = React.useState([]);
  const [openClinical, setOpenClinical] = React.useState(false);
  const [openAllergy, setOpenAllergy] = React.useState(false);
  const [allergyOption, setAllergyOption] = React.useState([]);
  const [selectedClinical, setSelectedClinical] = React.useState([]);
  const [openOtherReferral, setOpenOtherRefferal] = React.useState(false);
  const [selectedLocalAdvices, setSelectedLocalAdvices] = React.useState([]);
  const [referralDocOptions, setReferralDocOptions] = React.useState([]);
  const [clinicalValue, setClinicalValue] = React.useState("");
  const [selectedHistory, setSelectedHistory] = React.useState([]);
  const [selectedFamilyHistory, setSelectedFamilyHistory] = React.useState([]);
  const [selectedAdvices, setSelectedAdvices] = React.useState([]);
  const [selectedDiets, setSelectedDiets] = React.useState([]);
  const [emrId, setEmrId] = React.useState(null);
  const [completeEmr, setCompleteEmr] = React.useState(null);
  const [preview, setPreview] = React.useState("");
  const [openPreview, setOpenPreview] = React.useState(false);
  const [printObject, setPrintObject] = React.useState(null);
  const [isPreview, setIsPreview] = React.useState(false);
  const [isOpenPrev, setIsOpenPrev] = React.useState(false);
  const [applyToAllMedicines, setApplyToAllMedicines] = React.useState(false);
  const [editComplaintIndex, setEditComplaintIndex] = React.useState(null);
  const [formOpt, setFormOpt] = React.useState([]);
  const [servicesOptions, setServicesOptions] = React.useState([]);
  const [medicineTemplateData, setMedicineTemplateData] = React.useState();
  const [medicineTemplateValue, setMedicineTemplateValue] =
    React.useState(null);
  const [selectedMedicines, setSelectedMedicines] = React.useState([]);
  const [resetInv, setResetInv] = React.useState(0);
  const [selectedInvestigations, setSelectedInvestigations] = React.useState(
    [],
  );
  const [openSystemExam, setOpenSystemeticExam] = React.useState(false)
  const [openGeneralExam, setOpenGeneralExamModal] = React.useState(false)
  const [openNewSystematicExamTempalte, setNewTemplateForSystematicExam] = React.useState(false)
  const [complaintsOptions, setComplaintsOptions] = React.useState([]);
  const [emrTemplateOption, setEmrTemplateOption] = React.useState([]);
  const [pastHistoryOptions, setPastHistoryOptions] = useState([]);
  const [openPrintModal, setOpenPrintModal] = React.useState(false);
  const [selectedEMRTemplate, setSelectedEMRTemplate] = React.useState(false);
  const [followupAfterValue, setFollowupAfterValue] = useState("D");
  const [isFollowupDateValid, setIsFollowupDateValid] = useState(true);
  const [openOldMedicationsModal, setOpenOldMedicationsModal] = useState(false);
  const [oldMedicationsList, setOldMedicationsList] = useState([]);
  const [openLabModal, setOpenLabModal] = useState(false);
  const [startConsultation, setStartConsultation] = useState(false);
  const [selectedHopis, setSelectedHopis] = useState("");
  const [selectedGeneralExam, setSelectedGeneralExam] = React.useState("")
  const [selectedAdvice, setSelectedAdvice] = React.useState("")
  const [selectedPastHistory, setSelectedPastHistory] = React.useState("")
  const [famlilyHistroy, setFamilyHistory] = React.useState("")
  const [allergySuggestions, setAllergySuggestions] = React.useState("")
  const [selectedDietExcerises, setSelectedDietExercises] = React.useState("")
  const [suggestedData, setSuggestedData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openAdviceMoal, setOpenAdviceModal] = React.useState(false)
  const [openDietExercise, setDietExercise] = React.useState(false)
  const [selectedFieldId, setSelectedFieldId] = useState(null);
  const [openPastHistoryModal, setOpenPastHistoryModal] = React.useState(false)
  const [openFamilyHistoryTempModal, setOpenFamilyHistoryTempModal] = React.useState(false)
  const [templateValue, setTemplateValue] = useState("");
  const [openComplaintTempModal, setOpenComplaintTempModal] = React.useState(false)
  const [openAllergyTemplateModal, setOpenAllergyTemplateModal] = React.useState(false)
  console.log("selectedIdselectedIdselectedIdselectedId");
  const [previousEmrData, setPreviousEmrData] = React.useState(null)
  const schema = yup
    .object()
    .shape({
      medicine: yup.array().of(
        yup.object().shape({
          // Dosage: yup.string().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) => schema.required("Dosage is required"),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          // Frequency: yup.mixed().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) =>
          //     schema
          //       .test((val) => typeof val === "object")
          //       .required("Frequency is required"),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          // Route: yup.mixed().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) =>
          //     schema
          //       .test((val) => typeof val === "object")
          //       .required("Route is required"),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          // Duration: yup.string().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) => schema.required("Duration is required"),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          // Quantity: yup.string().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) => schema.required("Quantity is required"),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          // Instructions: yup.mixed().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) =>
          //     schema
          //       .test((val) => typeof val === "object")
          //       .required("Instructions are required"),
          //   otherwise: (schema) => schema.notRequired(),
          // // }),
          // Generic: yup.mixed().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) =>
          //     schema
          //       .test((val) => typeof val === "object")
          //       .required("Generic is required"),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          // Form: yup.mixed().when("Medicine", {
          //   is: (val) => val !== null && val !== "",
          //   then: (schema) =>
          //     schema
          //       .test((val) => typeof val === "object")
          //       .required("Form is required"),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
          // since: yup.string().nullable(),
          // isDeleted: yup.boolean(),
        }),
      ),
    })
    .required();

  const defaultValues = {
    height: "",
    weight: "",
    bmi: "",
    bp: "",
    pulse: "",
    bsl: "",
    respiration: "",
    temperature: "",
    spo2: "",
    searchDiagnosis: null,
    referralDoctor: null,
    admission: false,
    physiotherapy: false,
    dietician: false,
    procedures: false,
    nextFollowupDate: null,
    Tobacco: false,
    Smoking: false,
    Alcohol: false,
    searchOtherServices: null,
    searchEmrTemplate: null,
    followupAfterDuration: null,
    // Newly Added Values
    hopi: "",
    rs: "",
    advices: "",
    pastHistory: "",
    familyHistory: "",
    dietExerices: "",
    complaints: "",
    allergy: "",
    cvs: "",
    cns: "",
    pa: "",
    seOther: "",
    generalExaminations: "",
    searchDietExercise: null,
    reviewOfLab: "",
  };

  const {
    watch,
    setValue,
    control,
    trigger,
    register,
    setError,
    clearErrors,
    reset,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  console.log("errors321", errors);

  let complaintWatch = watch("createComplaint");
  let investigationWatch = watch("searchInvestigations");
  let diagnosisWatch = watch("searchDiagnosis");
  let nextFollowupDate = watch("nextFollowupDate");
  let allergyWatch = watch("searchAllergy");
  let otherReferralWatch = watch("referralDoctor");
  let advicesWatch = watch("searchAdvices");
  let watchOtherServices = watch("searchOtherServices");
  let getFollowupAfterDuration = watch("followupAfterDuration");
  let pastHistoryVal = watch("pastHistory")
  let familyHistoryVal = watch("familyHistory")
  let getHopi = watch("hopi");
  let complaintsVal = watch("complaints")
  let advicesVal = watch("advices")
  let getRS = watch("rs");
  let getCVS = watch("cvs");
  let getCNS = watch("cns");
  let getPA = watch("pa");
  let getOther = watch("seOther");
  let getGeneralExaminations = watch("generalExaminations");
  let getReviewOfLab = watch("reviewOfLab");
  let allergyVal = watch("allergy")
  let dietExericesVal = watch("dietExerices")
  console.log("getHopigetHopigetHopi", getHopi);

  const [
    heightWatch,
    weightWatch,
    bmiWatch,
    bpWatch,
    pulseWatch,
    temperatureWatch,
    spo2Watch,
    respirationWatch,
    bslWatch,
  ] = watch([
    "height",
    "weight",
    "bmi",
    "bp",
    "pulse",
    "temperature",
    "spo2",
    "respiration",
    "bsl",
  ]);
  const watchEMRTemplateValue = watch("searchEmrTemplate");
  let tobaccoWatch = watch("Tobacco");
  let smokingWatch = watch("Smoking");
  let alcoholWatch = watch("Alcohol");

  React.useEffect(() => {
    if (preview !== "") {
      setOpenPreview(true);
    }
  }, [preview]);

  React.useEffect(() => {
    emrTemplateList(token?.doctorId)
      .then((response) => response.data)
      .then((res) => {
        setEmrTemplateOption(res.result);
      })
      .catch((err) => err);

    getMedicationInstructions()
      .then((response) => response.data)
      .then((res) => {
        setMedicineInstructions(res.result);
      })
      .catch((err) => err);

    getDrugForm()
      .then((response) => response.data)
      .then((res) => {
        setFormOpt(res.result);
      })
      .catch((err) => err);

    getAdviceDropDownData()
      .then((response) => response.data)
      .then((res) => {
        setAdvicesOptions(res?.result);
      })
      .catch((err) => err);

    getGeneralFrequencies(0)
      .then((response) => response.data)
      .then((res) => {
        setFrequencyOptions(res?.result);
      })
      .catch((err) => err);

    getCommonRoutes()
      .then((response) => response.data)
      .then((res) => {
        setRoutes(res?.result);
      })
      .catch((err) => err);

    getCommonPastHistoryList(selectedRow?.["Doctor Id"]).then((response) => {
      console.log("commonHistoryResponse", response.data.result);
    });
  }, []);

  React.useEffect(() => {
    if (selectedRow !== null) {
      getPreviousDetails({
        opdIpdId: selectedRow?.VisitId,
        patientId: 0,
      });

      getPrevEmrList(0, selectedRow?.PatientId)
        .then((response) => response.data)
        .then((res) => {
          setLastVisits(res.result);
        })
        .catch((err) => err);
    }
  }, []);

  const getPreviousEmrData = () => {
    if (!selectedRow) return;

    getPatientEmrPatch(
      0,
      selectedRow?.VisitId,
      selectedRow?.["Doctor Id"],
      false,
      selectedRow?.PatientId
    )
      .then((response) => response.data)
      .then((res) => {
        console.log("getPatientEmrPatchgetPatientEmrPatchgetPatientEmrPatch", res);

        setPreviousEmrData(res.result[0]);

        setValue("pastHistory", res?.result[0]?.emrPastHistory)
        setValue("familyHistory", res?.result[0]?.emrFamilyHistory)
        setValue("dietExerices", res?.result[0]?.emrDiet)
        setValue("complaints", res?.result[0]?.emrComplaints)
        setValue("allergy", res?.result[0]?.emrAllergies)
        setValue("advices", res?.result[0]?.emrAdvices)


      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    console.log("thisisisisisisiis", selectedRow);

    getPreviousEmrData();
  }, [selectedRow]);

  React.useEffect(() => {
    const weightValue = parseFloat(Number(weightWatch));
    const heightValue = parseFloat(Number(heightWatch));
    let heightINCM = heightValue * 0.01;
    if (Number(heightWatch) > 0 && Number(weightWatch) > 0) {
      const bmiValue = weightValue / (heightINCM * heightINCM);
      setValue("bmi", bmiValue.toFixed(2));
    }
  }, [heightWatch, weightWatch]);

  const handleClosePreview = (reset) => {
    if (openPreview === true) {
      setOpenPreview(false);
      setPreview("");
      if (isPreview === false) {
        handleResetAll();
        navigate("/opd/visitlist", {
          state: { menuId: location?.state?.visitListMenuId },
        });
      }
    }
  };

  const handleClosePost = () => {
    if (openPost === true) {
      setOpenPost(false);
    }
  };

  const handleCloseClinical = () => {
    if (openClinical === true) {
      setOpenClinical(false);
    }
  };

  const handleCloseAllergy = () => {
    if (openAllergy === true) {
      setOpenAllergy(false);
    }
  };

  React.useEffect(() => {
    if (selectedClinical?.length > 0) {
      let clinicalFindingTemplate = "";
      for (let obj of selectedClinical) {
        clinicalFindingTemplate =
          clinicalFindingTemplate + obj?.templateDescription + `\n`;
        setClinicalValue(clinicalFindingTemplate);
      }
    }
  }, [selectedClinical]);

  const handleClosePathologyReport = () => {
    if (openPathologyReport === true) {
      setOpenPathologyReport(false);
    }
  };

  const handleCloseAdviceTemplate = () => {
    if (openAdviceTemplate === true) {
      setOpenAdviceTemplate(false);
    }
  };

  const handleCloseServices = () => {
    if (openServices === true) {
      setOpenServices(false);
    }
  };

  const handleCloseInvestigation = () => {
    if (openInvestigation === true) {
      setOpenInvestigation(false);
    }
  };

  const handleCloseDiagnosis = () => {
    if (openDiagnosis === true) {
      setOpenDiagnosis(false);
    }
  };

  const handleCloseComplaints = () => {
    if (openComplaints === true) {
      setOpenComplaints(false);
    }
  };

  const handleClosePastHistory = () => {
    if (openPastHistory === true) {
      setOpenPastHistory(false);
    }
  };

  const handleCloseFamilyHistory = () => {
    if (openFamilyHistory === true) {
      setOpenFamilyHistory(false);
    }
  };

  const handlePrintPreview = () => {
    let medicines = [];
    let filtered = selectedMedicines.filter((item) => item?.Medicine !== "");
    if (filtered?.length > 0) {
      for (let object of filtered) {
        let medicineObject = {
          code: object?.Medicine?.code,
          drugName: object?.Medicine?.Medicine,
          drugType: "Brand Name",
          days: Number(object?.since) > 0 ? Number(object?.since) : "",
          frequency: object?.Frequency?.label,
          genericDescription: object?.Medicine?.genericDesc,
          id: object?.Medicine?.id,
          isNew: true,
          localFrequency: null,
          localInstruction: null,
          drugId: object?.Medicine?.id,
        };
        medicines.push(medicineObject);
      }
    }

    let investigations = [];
    if (selectedInvestigations?.length > 0) {
      for (let object of selectedInvestigations) {
        let invObject = {
          testType: "Pathology",
          testTypeId: object?.testTypeId,
          investigation: object?.label,
          investigationImageName: null,
          investigationPathBase64: null,
          testId: object.id,
          serviceId: object?.serviceId,
          deleteFlag: false,
          id: object?.id,
          isUrgent: false,
          isNew: true,
        };
        investigations.push(invObject);
      }
    }

    let diagnosisArray = [];
    if (selectedDiagnosis?.length > 0) {
      for (let diagno of selectedDiagnosis) {
        diagnosisArray.push(diagno?.label);
      }
    }

    let complaintsArray = [];
    if (selectedComplaints?.length > 0) {
      for (let complaint of selectedComplaints) {
        let complaintObj = {
          complaint: complaint?.label,
        };
        complaintsArray.push(complaintObj);
      }
    }

    let advicesArray = [];
    if (adviceTemplates?.length > 0) {
      for (let template of adviceTemplates) {
        let advices = template?.Advices;
        if (advices?.length > 0) {
          for (let adv of advices) {
            advicesArray.push(adv);
          }
        }
      }

      if (selectedLocalAdvices?.length > 0) {
        for (let advice of selectedLocalAdvices) {
          advicesArray.push(advice?.value);
        }
      }
    }

    let diastolicValue = Number(bpWatch?.toString().split("/")?.[1]);
    let systolicValue = Number(bpWatch?.toString().split("/")?.[0]);

    let printObject = {
      clientId: 3,
      visitId: location?.state?.visitId,
      employeeId: loggedUser?.employeeId,
      nextFollowUpDate: nextFollowupDate
        ? format(nextFollowupDate, "yyyy-MM-dd")
        : null,
      medicineDetails: medicines,
      pathologyList: investigations,
      radiologyList: [],
      instructionList: advicesArray,
      vitals: {
        avpu: "",
        bloodPressureDiastolic: Number(diastolicValue),
        bloodPressureSystolic: Number(systolicValue),
        bloodSugar: 0,
        bmi: Number(bmiWatch),
        bsa: 0,
        cvp: 0,
        cyanosis: true,
        date: format(new Date(), "yyyy-MM-dd"),
        height: Number(heightWatch),
        mews: 0,
        peripheralPulse: 0,
        pews: 0,
        pulseRate: Number(pulseWatch),
        pulseType: "",
        respiration: 0,
        respirationType: "",
        spO2: Number(spo2Watch),
        temperature: Number(temperatureWatch),
        weight: Number(weightWatch),
        diagnosisList: diagnosisArray,
      },
      patientEmr: {
        treatmentAdviceDescription: null,
        complaints: complaintsArray,
      },
      separatePage: false,
      pageSize: "A4",
    };

    setPrintObject(printObject);
    setOpenPreview(true);
  };

  const renderPrint = () => {
    setTimeout(() => {
      setOpenPrintModal(false);
    }, 2000);

    return (
      <div className="hidden">
        <EMRPrescriptionPrint
          selectedRow={selectedRow}
          selectedVisitRow={selectedVisitRow}
        />
      </div>
    );
  };

  const getPreviousDetails = (lastVisit) => {
    setOpenEMrBackdrop(false);
    if (lastVisit.opdIpdId !== null || lastVisit.opdIpdId !== undefined) {
      getPatientEmrPatch(
        0,
        lastVisit?.opdIpdId,
        selectedRow?.["Doctor Id"],
        false,
        lastVisit?.patientId,
      )
        .then((response) => response.data)
        .then((res) => {
          if (res?.result?.length > 0) {
            let prevData = res?.result[0];
            console.log("prevDataprevDataprevDataprevDataprevData", prevData);

            setPreviousEmrData(prevData)
            if (!prevData?.id) {
              setStartConsultation(true);
            }

            setEmrId(
              prevData.id && lastVisit?.patientId === 0 ? prevData.id : null,
            );
            setCompleteEmr(
              prevData?.isComplete && lastVisit?.patientId === 0 ? true : false,
            );
            setValue("temperature", prevData.temp ? prevData.temp : "");
            setValue("bp", prevData.bp ? prevData.bp : "");
            setValue("pulse", prevData.pulse);
            setValue(
              "respiration",
              prevData.respiration ? prevData.respiration : "",
            );
            setValue("spo2", prevData.spo2 ? prevData.spo2 : "");
            setValue("bsl", prevData.bsl ? prevData.bsl : "");
            setValue("height", prevData.height ? prevData.height : "");
            setValue("weight", prevData.weight ? prevData.weight : "");
            setValue("bmi", prevData?.bmi);
            setValue("Smoking", prevData?.smoking);
            setValue("Tobacco", prevData?.tobacco);
            setValue("Alcohol", prevData?.alcohol);
            setValue("hopi", prevData?.hopi);
            setValue("rs", prevData?.rs);
            setValue("cvs", prevData?.cvs);
            setValue("cns", prevData?.cns);
            setValue("pa", prevData?.pa);
            setValue("seOther", prevData?.seOther);

            setValue("reviewOfLab", prevData?.reviewOfLab);
            setImpNotes(prevData?.importantNotes);
            setValue("pastHistory", prevData?.emrPastHistory)
            setValue("familyHistory", prevData?.emrFamilyHistory)
            setValue("dietExerices", prevData?.emrDiet)
            setValue("complaints", prevData?.emrComplaints)
            setValue("allergy", prevData?.emrAllergies)
            setValue("advices", prevData?.emrAdvices)
            setValue(
              "nextFollowupDate",
              prevData.newFollowupDate && lastVisit?.patientId === 0
                ? new Date(prevData?.newFollowupDate)
                : null,
            );

            let pastHistory = JSON.parse(prevData?.emrPastHistory || "[]");





            let services = JSON.parse(prevData?.emrServices || "[]");
            let selectedInvestigations = [];
            let otherServices = [];

            if (services.length > 0) {
              for (let serv of services) {
                let serviceObj = {
                  id: lastVisit?.patientId === 0 ? serv?.Id : null,
                  serviceMaster: serv?.service_id,
                  label: serv?.description,
                  value: serv?.description,
                  groupId: serv?.GroupId,
                };

                if (serviceObj.groupId === 2 || serviceObj.groupId === 32) {
                  selectedInvestigations.push(serviceObj);
                } else {
                  otherServices.push(serviceObj);
                }
              }

              setSelectedInvestigations(selectedInvestigations);
              setOtherServices(otherServices);
            } else {
              setSelectedInvestigations([]);
              setOtherServices([]);
            }

            let prescriptions = JSON.parse(prevData?.emrMedications || "[]");
            let medicineArray = [];

            if (prescriptions?.length > 0) {
              for (let i = 0; i < prescriptions.length; i++) {
                let prescriptionObject = {
                  id: lastVisit?.patientId === 0 ? prescriptions[i]?.id : null,
                  Medicine: {
                    id: prescriptions[i]?.drug_id
                      ? prescriptions[i]?.drug_id
                      : null,
                    label: prescriptions[i]?.drug_name
                      ? prescriptions[i]?.drug_name
                      : "",
                    value: prescriptions[i]?.drug_id
                      ? prescriptions[i]?.drug_id
                      : null,
                    Medicine: prescriptions[i]?.drug_name
                      ? prescriptions[i]?.drug_name
                      : "",
                  },
                  Dosage: prescriptions[i]?.dosage
                    ? prescriptions[i]?.dosage
                    : "",
                  Frequency: {
                    id: prescriptions[i]?.frequency_id
                      ? prescriptions[i]?.frequency_id
                      : null,
                    label: prescriptions[i]?.frequency_name
                      ? prescriptions[i]?.frequency_name
                      : "",
                    value: prescriptions[i]?.frequency_id
                      ? prescriptions[i]?.frequency_id
                      : null,
                  },
                  Route: {
                    Id: prescriptions[i]?.route_id
                      ? prescriptions[i]?.route_id
                      : null,
                    label: prescriptions[i]?.route_name
                      ? prescriptions[i]?.route_name
                      : "",
                    value: prescriptions[i]?.route_id
                      ? prescriptions[i]?.route_id
                      : null,
                  },
                  Duration: prescriptions[i]?.duration
                    ? prescriptions[i]?.duration
                    : "",
                  Quantity: prescriptions[i]?.quantity
                    ? prescriptions[i]?.quantity
                    : "",
                  Instructions: {
                    Id: prescriptions[i]?.instruction_id
                      ? prescriptions[i]?.instruction_id
                      : null,
                    label: prescriptions[i]?.instruction_name
                      ? prescriptions[i]?.instruction_name
                      : "",
                    value: prescriptions[i]?.instruction_id
                      ? prescriptions[i]?.instruction_id
                      : null,
                  },
                  Generic: {
                    id: prescriptions[i]?.generic_id
                      ? prescriptions[i]?.generic_id
                      : null,
                    label: prescriptions[i]?.generic_name
                      ? prescriptions[i]?.generic_name
                      : "",
                    value: prescriptions[i]?.generic_id
                      ? prescriptions[i]?.generic_id
                      : null,
                  },
                  Form: {
                    Id: prescriptions[i]?.form_id
                      ? prescriptions[i]?.form_id
                      : null,
                    label: prescriptions[i]?.form_name
                      ? prescriptions[i]?.form_name
                      : "",
                    value: prescriptions[i]?.form_id
                      ? prescriptions[i]?.form_id
                      : null,
                  },
                  isDeleted: false,
                  isNew: lastVisit?.PatientId === 0 ? false : true,
                };

                medicineArray?.push(prescriptionObject);
                setSelectedMedicines([...medicineArray, ...medicinesData]);

                // if (prescriptionObject?.Medicine?.Medicine) {
                //   setSelectedMedicines((prev) => {
                //     const dataArray = [...prev]; // clone state
                //     dataArray.splice(i, 1, prescriptionObject);

                //     const hasEmptyMedicine = prev.some(
                //       (val) => !val?.Medicine || val?.Medicine === ""
                //     );

                //     return hasEmptyMedicine
                //       ? dataArray
                //       : [...dataArray, ...medicinesData];
                //   });
                // }

                setValue(
                  `medicine[${i}].Quantity`,
                  prescriptionObject?.Quantity,
                );

                setValue(
                  `medicine[${i}].Instructions`,
                  prescriptionObject.Instructions,
                );

                setValue(`medicine[${i}].Form`, prescriptionObject.Form);

                setValue(`medicine[${i}].Generic`, prescriptionObject.Generic);
              }
            } else {
              handleResetMedicines();
            }

            let oldMedication = JSON?.parse(
              prevData?.emrOldMedications || "[]",
            );

            let patchOldMedications = [];
            for (let obj of oldMedication?.filter(
              (val) => val?.drug_name !== "" && val?.drug_name !== undefined,
            )) {
              let oldMedicationObj = {
                id: obj?.id ? obj?.id : null,
                Medicine: {
                  id: obj?.drug_id,
                  value: obj?.drug_id,
                  label: obj?.drug_name,
                },
                Frequency: {
                  id: obj?.frequency_id,
                  value: obj?.frequency_id,
                  label: obj?.frequency_name,
                },
                Generic: {
                  id: obj?.generic_id,
                  value: obj?.generic_id,
                  label: obj?.generic_name,
                },
                ison: obj?.ison === true ? "On" : "Off",
                isDelete: false,
                isNew: false,
              };
              patchOldMedications?.push(oldMedicationObj);
              setOldMedicationsList(patchOldMedications);
            }

            let daignosis = JSON.parse(prevData?.emrDiagnosis || "[]");
            console.log("editDiagnosiseditDiagnosis",daignosis);
            let editDiagnosis = [];

            if (daignosis?.length > 0) {
              for (let diagno of daignosis) {
                let diagnosisObj = {
                  label: diagno?.description,
                  id: lastVisit?.patientId === 0 ? diagno?.id : null,
                  value: diagno?.description,
                  since: diagno.since ? diagno.since : "",
                  duration: diagno.duration ? diagno.duration.charAt(0) : "",
                  isChecked: true,
                };

                editDiagnosis.push(diagnosisObj);
                
                setSelectedDiagnosis(editDiagnosis);
              }
            } else {
              setSelectedDiagnosis([]);
            }

            if (lastVisit?.patientId === 0) {
              let otherReferral = JSON.parse(
                prevData?.emrOtherReferrals || "[]",
              );
              let editOtherReferral = [];

              if (otherReferral.length > 0) {
                for (let otherReff of otherReferral) {
                  let otherRefferralObj = {
                    label: otherReff?.description,
                    id: otherReff?.id,
                    value: otherReff?.description,
                  };

                  editOtherReferral.push(otherRefferralObj);
                  setSelectedOtherReferral(editOtherReferral);
                }
              } else {
                setSelectedOtherReferral([]);
              }
            }
          } else {
            setEmrId(null);
            setCompleteEmr(false);
            setValue("temperature", "");
            setValue("bp", "");
            setValue("pulse", "");
            setValue("respiration", "");
            setValue("spo2", "");
            setValue("bsl", "");
            setValue("height", "");
            setValue("weight", "");
            setValue("bmi", "");
            setValue("Smoking", false);
            setValue("Tobacco", false);
            setValue("Alcohol", false);
            setValue("hopi", "");
            setValue("rs", "");
            setValue("cvs", "");
            setValue("cns", "");
            setValue("pa", "");
            setValue("seOther", "");
            setValue("generalExaminations", "");
            setValue("reviewOfLab", "");
            setImpNotes("");
            setValue("nextFollowupDate", null);
            setSelectedAdvices([]);
            setSelectedHistory([]);
            setSelectedFamilyHistory([]);
            setSelectedComplaints([]);
            setSelectedAllergy([]);
            setSelectedDiets([]);
            setSelectedInvestigations([]);
            setOtherServices([]);
            setSelectedMedicines([...medicinesData]);
            setValue(`medicine[${0}].Quantity`, "");
            setValue(`medicine[${0}].Instructions`, null);
            setValue(`medicine[${0}].Form`, null);
            setValue(`medicine[${0}].Generic`, null);
            setOldMedicationsList([]);
            setSelectedDiagnosis([]);
            setSelectedOtherReferral([]);
          }
        })
        .catch((err) => err);
    }
  };
  // load emr data on click of past history button


  const loadEmrImpNotes = () => {
    console.log("previousEmrDatapreviousEmrDatapreviousEmrDatapreviousEmrData", previousEmrData);

    if (!previousEmrData) return
    setImpNotes(previousEmrData?.importantNotes)
  }

  const getEmrPastHistory = () => {
    if (!previousEmrData) return;
    let pastHistory = JSON.parse(previousEmrData?.emrPastHistory || "[]");
    let patchPastHistory = [];
    if (pastHistory?.length > 0) {
      for (let past of pastHistory) {
        let pastObject = {
          id: selectedRow?.patientId === 0 ? past?.id : null,
          label: past?.historyDesc,
          value: past?.historyDesc,
          description: past?.description,
          duration: past?.duration,
          since: past?.since,
          isChecked: true,
        };
        patchPastHistory?.push(pastObject);
        setSelectedHistory(patchPastHistory);
      }
    } else {
      setSelectedHistory([]);
    }

  }

  const getEmrFamilyHistory = () => {
    if (!previousEmrData) return;

    let familyHistory = JSON.parse(previousEmrData?.emrFamilyHistory || "[]");
    let patchFamilyHistory = [];
    if (familyHistory?.length > 0) {
      for (let family of familyHistory) {
        let familyObject = {
          id: selectedRow?.patientId === 0 ? family?.id : null,
          label: family?.historyDesc,
          value: family?.historyDesc,
          description: family?.description,
          duration: family?.duration,
          since: family?.since,
          isChecked: true,
        };
        patchFamilyHistory?.push(familyObject);
        setSelectedFamilyHistory(patchFamilyHistory);
      }
    } else {
      setSelectedFamilyHistory([]);
    }
  }


  const getEmrComplaintsHistroy = () => {
    if (!previousEmrData) return;

    let complaint = JSON.parse(previousEmrData?.emrComplaints || "[]");
    let editComplaint = [];

    console.log("EMR Details for complaint", complaint);

    if (complaint?.length > 0) {
      for (let comp of complaint) {
        let complaintObj = {
          id: selectedRow?.patientId === 0 ? comp?.id : null,
          label: comp?.complaint,
          value: comp?.complaint,
          since: comp?.since || "",
          duration: comp.duration ? comp?.duration.charAt(0) : "",
          description: comp?.description || "",
          isChecked: true,
        };

        editComplaint.push(complaintObj);
        setSelectedComplaints(editComplaint);
      }
    } else {
      setSelectedComplaints([]);
    }
  }

  const getEmrAllergiesPastHistory = () => {
    if (!previousEmrData) return;
    let allergies = JSON.parse(previousEmrData?.emrAllergies || "[]");
    let editAllergy = [];

    if (allergies?.length > 0) {
      for (let allergy of allergies) {
        console.log();

        let allergyObj = {
          id: selectedRow?.patientId === 0 ? allergy?.id : null,
          label: allergy?.description,
          value: allergy?.description,
        };
        console.log("EMR Details for allergyObj", allergyObj);
        editAllergy.push(allergyObj);
        setSelectedAllergy(editAllergy);
      }
    } else {
      setSelectedAllergy([]);
    }

  }

  const getEmrDietAndExrciesePastHistory = () => {
    if (!previousEmrData) return;

    let tempDiet = JSON.parse(previousEmrData?.emrDiet || "[]");
    console.log("EMR Details for allergyObj", tempDiet);
    let editDiet = [];

    if (tempDiet?.length > 0) {
      for (let diet of tempDiet) {
        console.log();

        let allergyObj = {
          id: selectedRow?.patientId === 0 ? diet?.id : null,
          dietId: diet?.dietId ? diet?.dietId : null,
          description: diet?.description,
        };
        editDiet.push(allergyObj);
        setValue("dietExerices", allergyObj?.description)
        // setSelectedDiets(editDiet);
      }
    } else {
      setSelectedDiets([]);
    }

  }

  const getEmrInvestigationPastHistory = () => {
    if (!previousEmrData) return;

    let services = JSON.parse(previousEmrData?.emrServices || "[]");
    let selectedInvestigations = [];
    let otherServices = [];

    if (services.length > 0) {
      for (let serv of services) {
        let serviceObj = {
          id: selectedRow?.patientId === 0 ? serv?.Id : null,
          serviceMaster: serv?.service_id,
          label: serv?.description,
          value: serv?.description,
          groupId: serv?.GroupId,
        };

        if (serviceObj.groupId === 2 || serviceObj.groupId === 32) {
          selectedInvestigations.push(serviceObj);
        } else {
          otherServices.push(serviceObj);
        }
      }

      setSelectedInvestigations(selectedInvestigations);
      setOtherServices(otherServices);
    } else {
      setSelectedInvestigations([]);
      setOtherServices([]);
    }

  }

  const getEmrDiagnosisPastHistroy = () => {

    if (!previousEmrData) return;

    let daignosis = JSON.parse(previousEmrData?.emrDiagnosis || "[]");
    let editDiagnosis = [];

    if (daignosis?.length > 0) {
      for (let diagno of daignosis) {
        let diagnosisObj = {
          label: diagno?.description,
          id: selectedRow?.patientId === 0 ? diagno?.id : null,
          value: diagno?.description,
          since: diagno.since ? diagno.since : "",
          duration: diagno.duration ? diagno.duration.charAt(0) : "",
          isChecked: true,
        };

        editDiagnosis.push(diagnosisObj);
        setSelectedDiagnosis(editDiagnosis);
      }
    } else {
      setSelectedDiagnosis([]);
    }


  }

  const getEmrOtherReferealPastHistory = () => {
    if (!previousEmrData) return;

    if (selectedRow?.patientId === 0) {
      let otherReferral = JSON.parse(
        previousEmrData?.emrOtherReferrals || "[]",
      );
      let editOtherReferral = [];

      if (otherReferral.length > 0) {
        for (let otherReff of otherReferral) {
          let otherRefferralObj = {
            label: otherReff?.description,
            id: otherReff?.id,
            value: otherReff?.description,
          };

          editOtherReferral.push(otherRefferralObj);
          setSelectedOtherReferral(editOtherReferral);
        }
      } else {
        setSelectedOtherReferral([]);
      }
    }
  }
  const getEmrAdvicesPastHistory = () => {
    if (!previousEmrData) return;

    let advices = JSON.parse(previousEmrData?.emrAdvices || "[]");
    let editAdvice = [];

    console.log("EMR Details for advices", advices);

    if (advices.length > 0) {
      for (let adv of advices) {
        let adviceObj = {
          id: selectedRow?.patientId === 0 ? adv.id : null,
          label: adv.description,
          value: adv?.description,
        };
        editAdvice.push(adviceObj);

        setValue(
          "advices",
          editAdvice.map((x) => x.label).join("\n")
        );        // setSelectedAdvices(editAdvice);
      }
    } else {
      setSelectedAdvices([]);
    }
  }

  const getEmrMedicationsPastHistory = () => {
    if (!previousEmrData) return;
    let prescriptions = JSON.parse(previousEmrData?.emrMedications || "[]");
    let medicineArray = [];

    if (prescriptions?.length > 0) {
      for (let i = 0; i < prescriptions.length; i++) {
        let prescriptionObject = {
          id: selectedRow?.patientId === 0 ? prescriptions[i]?.id : null,
          Medicine: {
            id: prescriptions[i]?.drug_id
              ? prescriptions[i]?.drug_id
              : null,
            label: prescriptions[i]?.drug_name
              ? prescriptions[i]?.drug_name
              : "",
            value: prescriptions[i]?.drug_id
              ? prescriptions[i]?.drug_id
              : null,
            Medicine: prescriptions[i]?.drug_name
              ? prescriptions[i]?.drug_name
              : "",
          },
          Dosage: prescriptions[i]?.dosage
            ? prescriptions[i]?.dosage
            : "",
          Frequency: {
            id: prescriptions[i]?.frequency_id
              ? prescriptions[i]?.frequency_id
              : null,
            label: prescriptions[i]?.frequency_name
              ? prescriptions[i]?.frequency_name
              : "",
            value: prescriptions[i]?.frequency_id
              ? prescriptions[i]?.frequency_id
              : null,
          },
          Route: {
            Id: prescriptions[i]?.route_id
              ? prescriptions[i]?.route_id
              : null,
            label: prescriptions[i]?.route_name
              ? prescriptions[i]?.route_name
              : "",
            value: prescriptions[i]?.route_id
              ? prescriptions[i]?.route_id
              : null,
          },
          Duration: prescriptions[i]?.duration
            ? prescriptions[i]?.duration
            : "",
          Quantity: prescriptions[i]?.quantity
            ? prescriptions[i]?.quantity
            : "",
          Instructions: {
            Id: prescriptions[i]?.instruction_id
              ? prescriptions[i]?.instruction_id
              : null,
            label: prescriptions[i]?.instruction_name
              ? prescriptions[i]?.instruction_name
              : "",
            value: prescriptions[i]?.instruction_id
              ? prescriptions[i]?.instruction_id
              : null,
          },
          Generic: {
            id: prescriptions[i]?.generic_id
              ? prescriptions[i]?.generic_id
              : null,
            label: prescriptions[i]?.generic_name
              ? prescriptions[i]?.generic_name
              : "",
            value: prescriptions[i]?.generic_id
              ? prescriptions[i]?.generic_id
              : null,
          },
          Form: {
            Id: prescriptions[i]?.form_id
              ? prescriptions[i]?.form_id
              : null,
            label: prescriptions[i]?.form_name
              ? prescriptions[i]?.form_name
              : "",
            value: prescriptions[i]?.form_id
              ? prescriptions[i]?.form_id
              : null,
          },
          isDeleted: false,
          isNew: selectedRow?.PatientId === 0 ? false : true,
        };

        medicineArray?.push(prescriptionObject);
        setSelectedMedicines([...medicineArray, ...medicinesData]);

        // if (prescriptionObject?.Medicine?.Medicine) {
        //   setSelectedMedicines((prev) => {
        //     const dataArray = [...prev]; // clone state
        //     dataArray.splice(i, 1, prescriptionObject);

        //     const hasEmptyMedicine = prev.some(
        //       (val) => !val?.Medicine || val?.Medicine === ""
        //     );

        //     return hasEmptyMedicine
        //       ? dataArray
        //       : [...dataArray, ...medicinesData];
        //   });
        // }

        setValue(
          `medicine[${i}].Quantity`,
          prescriptionObject?.Quantity,
        );

        setValue(
          `medicine[${i}].Instructions`,
          prescriptionObject.Instructions,
        );

        setValue(`medicine[${i}].Form`, prescriptionObject.Form);

        setValue(`medicine[${i}].Generic`, prescriptionObject.Generic);
      }
    } else {
      handleResetMedicines();
    }

  }

  const getEmrHOPIPastHistory = () => {
    if (!previousEmrData) return;
    setValue("hopi", previousEmrData?.hopi)
  }

  const getEmrReviewOfLab = () => {
    if (!previousEmrData) return;
    setValue("reviewOfLab", previousEmrData?.reviewOfLab)
  }









  const handleEditComplaint = (complaintObject, complaintIndex) => {
    let patchComplaint = {
      id: complaintObject?.value,
      label: complaintObject?.label,
      value: complaintObject?.value,
    };
    setValue("createComplaint", patchComplaint);
    setEditComplaintIndex(complaintIndex);
  };

  const handleUpdateComplaint = () => {
    let newComplaint = {
      id: complaintWatch?.__isNew__ === true ? null : complaintWatch.id,
      label: complaintWatch.label,
      value: complaintWatch.value || null,
      since: "",
      duration: "D",
      description: "",
      isChecked: true,
    };

    let dataArray = [...selectedComplaints];
    let filtered = dataArray.filter(
      (complaint) => complaint?.label === complaintWatch?.label,
    );
    if (filtered?.length === 0) {
      dataArray.splice(editComplaintIndex, 1, newComplaint);
      setSelectedComplaints(dataArray);
      setValue("createComplaint", null);
      setEditComplaintIndex(null);
    } else {
      errorAlert("Complaint already exists.");
      setEditComplaintIndex(null);
      setValue("createComplaint", null);
    }
  };

  const handleDeleteComplaints = (complaint) => {
    const combinedArray = [...complaints];
    const uniqueArray = Array.from(
      new Map(combinedArray.map((item) => [item.label, item])).values(),
    );

    uniqueArray.sort((a, b) => {
      if (a.value === null) return 1;
      if (b.value === null) return -1;
      return a.value - b.value;
    });
    let dataArrayTwo = [...uniqueArray];
    for (let object of dataArrayTwo) {
      if (object?.label === complaint?.label) {
        object.isChecked = !object.isChecked;
      }
    }

    setComplaints(dataArrayTwo);

    let dataArray = [...selectedComplaints];
    let filtered = dataArray.filter((item) => item !== complaint);
    setSelectedComplaints(filtered);
  };

  const handleDeleteDiagnosis = (diagno) => {
    const combinedArray = [...diagnosis];
    const uniqueArray = Array.from(
      new Map(combinedArray.map((item) => [item.label, item])).values(),
    );

    uniqueArray.sort((a, b) => {
      if (a.value === null) return 1;
      if (b.value === null) return -1;
      return a.value - b.value;
    });
    let dataArrayTwo = [...uniqueArray];
    for (let object of dataArrayTwo) {
      if (object?.label === diagno?.label) {
        object.isChecked = !object.isChecked;
      }
    }

    setDiagnosis(dataArrayTwo);

    let dataArray = [...selectedDiagnosis];
    let filtered = dataArray.filter((item) => item !== diagno);
    setSelectedDiagnosis(filtered);
  };

  const handleDeleteAdvice = (advice) => {
    let dataArray = [...selectedAdvices];
    let filtered = dataArray.filter((item) => item.value !== advice.value);
    setSelectedAdvices(filtered);
  };

  const handleDeleteLocalAdvices = (localAdvice) => {
    const updatedLocalAdvices = selectedLocalAdvices.filter(
      (item) => item.value !== localAdvice.value,
    );
    setSelectedLocalAdvices(updatedLocalAdvices);
  };

  const handleDeleteAllergy = (allergy) => {
    let dataArray = [...selectedAllergy];
    let filtered = dataArray.filter((item) => item != allergy);
    setSelectedAllergy(filtered);
  };

  const handleDeleteInv = (inv) => {
    let dataArray = [...selectedInvestigations];
    let filtered = dataArray.filter((item) => item !== inv);
    setSelectedInvestigations(filtered);
    setResetInv(resetInv + 1);
  };

  const handleDeleteOtherService = (row) => {
    let dataArray = [...otherServices];
    let filtered = dataArray.filter((item) => item !== row);
    setOtherServices(filtered);
    setResetServices(resetServices + 1);
  };

  const handleDeleteOtherReferral = (row) => {
    let dataArray = [...selectedOtherReferral];
    let filtered = dataArray.filter((item) => item !== row);
    setSelectedOtherReferral(filtered);
  };

  const handleGetTemplateMedicine = (e) => {
    if (e !== "") {
      setMedicineTemplateData(templateData);
    }
  };

  const getMedicineTemplate = () => {
    if (medicineTemplateValue !== null) {
      emrTemplateEditData(medicineTemplateValue.id)
        .then((response) => response.data)
        .then((res) => {
          let templateMedicineData = JSON.parse(
            res?.result[0]?.emrItems || "[]",
          );

          let updatedMedicines = [...selectedMedicines];
          for (let i = 0; i < templateMedicineData.length; i++) {
            const medicine = templateMedicineData[i];

            const medicineObj = {
              Medicine: {
                id: medicine?.item_id,
                label: medicine?.item_name,
                value: medicine?.item_name,
                Medicine: medicine?.item_name,
              },
              Dosage: medicine?.dosage,
              Frequency: {
                id: medicine?.frequency_id,
                label: medicine?.frequency_name,
                value: medicine?.frequency_name,
              },
              Route: {
                Id: medicine?.route_id,
                label: medicine?.route_name,
                value: medicine?.route_name,
              },
              Duration: medicine?.duration,
              Quantity: medicine?.quantity,
              Instructions: {
                Id: medicine?.instruction_id,
                label: medicine?.instruction_name,
                value: medicine?.instruction_name,
              },
              Generic: {
                id: medicine?.generic_id,
                label: medicine?.generic_name,
                value: medicine?.generic_name,
              },
              Form: {
                Id: medicine?.form_id,
                label: medicine?.form_name,
                value: medicine?.form_name,
              },
              isDeleted: false,
              since: "",
            };
            updatedMedicines[i] = medicineObj;
            setValue(`medicine[${i}].Medicine`, medicineObj.Medicine);
            setValue(`medicine[${i}].Dosage`, medicine?.Dosage);
            setValue(`medicine[${i}].Frequency`, medicineObj.Frequency);
            setValue(`medicine[${i}].Route`, medicineObj.Route);
            setValue(`medicine[${i}].Duration`, medicineObj?.Duration);
            setValue(`medicine[${i}].Quantity`, medicineObj?.Quantity);
            setValue(`medicine[${i}].Instructions`, medicineObj.Instructions);
            setValue(`medicine[${i}].Generic`, medicineObj.Generic);
            setValue(`medicine[${i}].Form`, medicineObj.Form);
          }

          setSelectedMedicines([...updatedMedicines, ...medicinesData]);
        })
        .catch((err) => err);
    } else {
      handleResetMedicines();
    }
  };

  useEffect(() => {
    getMedicineTemplate();
  }, [medicineTemplateValue]);

  const handleGetMedicine = (search) => {
    if (search !== "" && UseCheckConsecutiveCharacters(search)) {
      getMedicines(search)
        .then((response) => {
          setSearchMedicines(response.data.result);
        })
        .catch((error) => error);
    } else {
      setSearchMedicines([]);
    }
  };

  const handleGetGenerics = (searchGenericName) => {
    if (
      searchGenericName &&
      searchGenericName !== undefined &&
      UseCheckConsecutiveCharacters(searchGenericName)
    ) {
      getGenericDrugs(searchGenericName)
        .then((response) => response.data)
        .then((res) => {
          setGenericDrugs(res.result);
        });
    }
  };

  const normalizeMedicine = (medicine) => ({
    id: medicine?.drug_id ?? medicine?.id,
    label: medicine?.drug_name ?? medicine?.label,
    value: medicine?.drug_id ?? medicine?.id,

    genericId: medicine?.generic_id ?? medicine?.genericId,
    genericName: medicine?.generic_name ?? medicine?.genericName,

    formId: medicine?.form_id ?? medicine?.formId,
    form: medicine?.form_name ?? medicine?.form,

    frequencyId: medicine?.frequency_id ?? medicine?.frequencyId,
    frequencyName: medicine?.frequency_name ?? medicine?.frequencyName,

    instructionId: medicine?.instruction_id ?? medicine?.instructionId,
    instructionName:
      medicine?.instruction_name ?? medicine?.instructionName,

    routeId: medicine?.route_id ?? medicine?.routeId,
    routeName: medicine?.route_name ?? medicine?.routeName,

    duration: medicine?.duration,
  });

  const handleAllDurations = (isApply) => {
    let dataArray = [...selectedMedicines];
    let firstMedicine = dataArray[0];
    if (isApply === true) {
      for (let medicine of dataArray) {
        if (
          firstMedicine?.Medicine !== "" &&
          Number(firstMedicine?.since) > 0
        ) {
          if (
            medicine?.Medicine !== "" &&
            medicine?.Medicine?.id !== firstMedicine?.Medicine?.id
          ) {
            medicine.since = firstMedicine?.since;
          }
        }
      }
      setSelectedMedicines(dataArray);
    } else if (isApply === false) {
      for (let medicine of dataArray) {
        if (
          medicine?.Medicine !== "" &&
          medicine?.Medicine?.id !== firstMedicine?.Medicine?.id
        ) {
          medicine.since = "";
        }
      }
      setSelectedMedicines(dataArray);
    }
  };

  const renderInput = (row, index, header) => {
    console.log("medicineRowValue", row);

    if (row?.Medicine === "") {
      setValue(`medicine[${index}].Medicine`, null);
    } else {
      setValue(`medicine[${index}].Medicine`, row?.Medicine);
    }

    if (row?.Medicine === "") {
      setValue(`medicine[${index}].Generic`, null);
      setValue(`medicine[${index}].Form`, null);
    }

    if (row?.Dosage === "") {
      setValue(`medicine[${index}].Dosage`, "");
    } else {
      setValue(`medicine[${index}].Dosage`, row?.Dosage);
    }

    if (row?.Frequency?.label !== "") {
      setValue(`medicine[${index}].Frequency`, row?.Frequency);
    } else {
      setValue(`medicine[${index}].Frequency`, null);
    }

    setValue(`duration[${index}].since`, row?.since);

    if (row?.Route === "") {
      setValue(`medicine[${index}].Route`, null);
    } else {
      setValue(`medicine[${index}].Route`, row?.Route);
    }

    if (row?.Duration === "") {
      setValue(`medicine[${index}].Duration`, "");
      setValue(`medicine[${index}].Duantity`, "");
    } else {
      setValue(`medicine[${index}].Duration`, row?.Duration);
    }

    const calculateQuantity = (frequency, duration) => {
      if (!frequency || !duration) return 0;

      let frequencyCountValue = 0;
      let freqArray = frequency.label.split("-");

      freqArray.forEach((element) => {
        let value = element.trim();

        if (value === "1/2" || value === "½") {
          frequencyCountValue += 0.5;
        } else if (value === "¼") {
          frequencyCountValue += 0.25;
        } else if (value === "1") {
          frequencyCountValue += 1;
        } else if (value === "1½") {
          frequencyCountValue += 1.5;
        } else if (value === "1/8") {
          frequencyCountValue += 0.125;
        } else if (value === "2") {
          frequencyCountValue += 2;
        } else if (value === "2½") {
          frequencyCountValue += 2.5;
        } else if (value === "3") {
          frequencyCountValue += 3;
        } else if (value === "3½") {
          frequencyCountValue += 3.5;
        } else if (value === "4") {
          frequencyCountValue += 4;
        } else if (value === "4½") {
          frequencyCountValue += 4.5;
        } else if (value === "STAT") {
          frequencyCountValue += 1;
        } else if (value === "Stat/sos") {
          frequencyCountValue += 1;
        } else if (value === "SOS") {
          frequencyCountValue += 1;
        }
      });

      const quantityCount = Number(duration) * frequencyCountValue;
      return Math.ceil(quantityCount);
    };

    return (
      <div className={`flex justify-start z-50`}>
        {header === "Medicine" ? (
          <div className="flex justify-start w-[25vw] lg:w-full">
            <CustomCreateable
              menuPlacement={"bottom"}
              width={"250px"}
              control={control}
              name={`medicine[${index}].Medicine`}
              placeholder={"Medicine"}
              handleInputChange={handleGetMedicine}
              isClearable={true}
              inputRef={{
                ...register(`medicine[${index}].Medicine`, {
                  onChange: async (e) => {
                    console.log("searchitemdatais", e?.target?.value);

                    const getUserInfo = JSON.parse(localStorage.getItem("userInfo"));

                    let medicineValue = e.target.value;

                    // Get doctor specific medicine if available
                    if (medicineValue?.id) {
                      try {
                        const response = await getMedicinesByDoctorItemId(
                          getUserInfo?.doctorId,
                          medicineValue.id
                        );

                        console.log(
                          "getMedicinesByDoctorItemId response",
                          response
                        );

                        if (response?.status === 200 && response?.data?.result) {
                          medicineValue = normalizeMedicine(response.data.result);
                        } else {
                          medicineValue = normalizeMedicine(medicineValue);
                        }
                      } catch (err) {
                        console.log("API failed. Using selected medicine.");
                        medicineValue = normalizeMedicine(medicineValue);
                      }
                    }

                    let dataArray = [...selectedMedicines];

                    if (medicineValue) {
                      const genericNameObj = medicineValue.genericId
                        ? {
                          id: medicineValue.genericId,
                          value: medicineValue.genericName,
                          label: medicineValue.genericName,
                        }
                        : null;

                      const formObj = medicineValue.formId
                        ? {
                          id: medicineValue.formId,
                          value: medicineValue.form,
                          label: medicineValue.form,
                        }
                        : null;

                      const frequencyObj = medicineValue.frequencyId
                        ? {
                          id: medicineValue.frequencyId,
                          value: medicineValue.frequencyName,
                          label: medicineValue.frequencyName,
                        }
                        : null;

                      const instructionObj = medicineValue.instructionId
                        ? {
                          id: medicineValue.instructionId,
                          value: medicineValue.instructionName,
                          label: medicineValue.instructionName,
                        }
                        : null;

                      const routeObj = medicineValue.routeId
                        ? {
                          id: medicineValue.routeId,
                          value: medicineValue.routeName,
                          label: medicineValue.routeName,
                        }
                        : null;

                      const filtered = dataArray.some(
                        (item, idx) =>
                          idx !== index &&
                          !item?.isDeleted &&
                          item?.Medicine?.id === medicineValue.id
                      );

                      if (!filtered) {
                        const newMedicine = {
                          id: medicineValue.__isNew__ ? null : medicineValue.id,
                          value: medicineValue.__isNew__ ? null : medicineValue.id,
                          label: medicineValue.label,
                        };

                        dataArray[index] = {
                          ...dataArray[index],
                          Medicine: newMedicine,
                          Generic: genericNameObj,
                          Form: formObj,
                          Frequency: frequencyObj,
                          Instructions: instructionObj,
                          Route: routeObj,
                          isDeleted: false,
                          isNew: true,
                        };

                        setValue(`medicine[${index}].Medicine`, newMedicine);

                        if (genericNameObj) {
                          setValue(`medicine[${index}].Generic`, genericNameObj);
                          clearErrors(`medicine[${index}].Generic`);
                        }

                        if (formObj) {
                          setValue(`medicine[${index}].Form`, formObj);
                          clearErrors(`medicine[${index}].Form`);
                        }

                        if (frequencyObj) {
                          setValue(`medicine[${index}].Frequency`, frequencyObj);
                          clearErrors(`medicine[${index}].Frequency`);
                        }

                        if (instructionObj) {
                          setValue(`medicine[${index}].Instructions`, instructionObj);
                          clearErrors(`medicine[${index}].Instructions`);
                        }

                        if (routeObj) {
                          setValue(`medicine[${index}].Route`, routeObj);
                          clearErrors(`medicine[${index}].Route`);
                        }

                        setSelectedMedicines(dataArray);

                        const nextField = document.querySelector(
                          `input[name="medicine[${index}].Dosage"]`
                        );
                        nextField?.focus();

                        if (index === selectedMedicines.length - 1) {
                          setSelectedMedicines([
                            ...dataArray,
                            ...medicinesData,
                          ]);
                        }
                      } else {
                        setValue(`medicine[${index}].Medicine`, null);
                        errorAlert("Medicine / Drug already exists");
                      }
                    } else {
                      setValue(`medicine[${index}].Medicine`, null);
                      setValue(`medicine[${index}].Generic`, null);
                      setValue(`medicine[${index}].Form`, null);
                      setValue(`medicine[${index}].Frequency`, null);
                      setValue(`medicine[${index}].Instructions`, null);
                      setValue(`medicine[${index}].Route`, null);

                      dataArray[index] = {
                        ...dataArray[index],
                        Medicine: "",
                        Generic: null,
                        Form: null,
                        Frequency: null,
                        Instructions: null,
                        Route: null,
                      };

                      if (index === dataArray.length - 1) {
                        dataArray.pop();
                      }

                      setSelectedMedicines(dataArray);
                    }
                  },
                }),
              }}
              dataArray={searchMedicines}
              isSearchable={true}
            />
          </div>
        ) : null}

        {header === "Dosage" ? (
          <div className="flex justify-start w-full ml-2">
            <input
              className={`h-7 w-32 border ${errors?.medicine?.[index]?.Dosage
                ? "border-red-500"
                : "border-gray-400"
                }  rounded px-2`}
              style={{ outline: "none" }}
              placeholder="Dosage"
              name={`medicine[${index}].Dosage`}
              {...register(`medicine[${index}].Dosage`)}
              onChange={(e) => {
                let dataArray = [...selectedMedicines];
                dataArray[index].Dosage = e.target.value;
                clearErrors(`medicine[${index}].Dosage`);
                setSelectedMedicines(dataArray);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  const nextField = document
                    .querySelector(`[name="medicine[${index}].Frequency"]`)
                    ?.closest(".w-full");
                  if (nextField) {
                    const selectInput = nextField.querySelector("input");
                    if (selectInput) {
                      selectInput.focus();
                      const selectDiv = nextField.querySelector(
                        ".css-1s2u09g-control",
                      );
                      if (selectDiv) {
                        selectDiv.click();
                      }
                    }
                  }
                }
              }}
            />
            {/* <InputField
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              width={"170px"}
              control={control}
              name={`medicine[${index}].Dosage`}
              label={"Dosage"}
              handleInputChange={handleGetRoutes}
              inputRef={{
                ...register(`medicine[${index}].Dosage`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Dosage = e.target.value;
                    setSelectedMedicines(dataArray);
                  },
                }),
              }}
            /> */}
          </div>
        ) : null}

        {header === "Frequency" ? (
          <div className="flex justify-start ml-2 w-[20vw] xl:w-full">
            <TableDropDownField
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              width={"170px"}
              control={control}
              name={`medicine[${index}].Frequency`}
              error={errors?.medicine?.[index]?.Frequency}
              placeholder={"Frequency"}
              handleInputChange={() => { }}
              isClearable={true}
              inputRef={{
                ...register(`medicine[${index}].Frequency`, {
                  onChange: (e) => {
                    if (
                      e.target.value !== null &&
                      e.target.value !== undefined
                    ) {
                      let dataArray = [...selectedMedicines];
                      dataArray[index].Frequency = e.target.value;

                      const duration = dataArray[index].Duration;
                      if (duration) {
                        const quantity = calculateQuantity(
                          e.target.value,
                          duration,
                        );
                        setValue(`medicine[${index}].Quantity`, quantity);
                        dataArray[index].Quantity = quantity;
                      }

                      setSelectedMedicines(dataArray);
                      const nextField = document
                        .querySelector(`[name="medicine[${index}].Route"]`)
                        ?.closest(".w-full");

                      if (nextField) {
                        const routeInput = nextField.querySelector("input");
                        if (routeInput) {
                          routeInput.focus();
                        }
                      }
                    } else {
                      let dataArray = [...selectedMedicines];
                      dataArray[index].Frequency = "";
                      setValue(`medicine[${index}].Quantity`, 0);
                      dataArray[index].Quantity = 0;
                      setSelectedMedicines(dataArray);
                    }
                  },
                }),
              }}
              dataArray={frequencyOptions}
              isSearchable={true}
            />
          </div>
        ) : null}

        {header === "Route" ? (
          <div className="flex justify-start w-[17vw] xl:w-full ml-2">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              width={"170px"}
              control={control}
              name={`medicine[${index}].Route`}
              error={errors?.medicine?.[index]?.Route}
              placeholder={"Route"}
              handleInputChange={() => { }}
              inputRef={{
                ...register(`medicine[${index}].Route`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Route = e.target.value;
                    setSelectedMedicines(dataArray);
                    const nextField = document.querySelector(
                      `input[name="medicine[${index}].Duration"]`,
                    );
                    nextField?.focus();
                  },
                }),
              }}
              dataArray={routes}
              isSearchable={true}
              isClearable={true}
            />
          </div>
        ) : null}

        {header === "Duration" ? (
          <div className="flex gap-2 items-center ml-2">
            <input
              disabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              name={`medicine[${index}].Duration`}
              {...register(`medicine[${index}].Duration`)}
              style={{ outline: "none" }}
              placeholder="Duration"
              className={`h-7 w-32 border ${errors?.medicine?.[index]?.Duration
                ? "border-red-500"
                : "border-gray-400"
                }  rounded px-2`}
              value={row?.Duration}
              onChange={(e) => {
                let dataArray = [...selectedMedicines];
                dataArray[index].Duration = e.target.value;
                const frequency = dataArray[index].Frequency;
                if (frequency) {
                  const quantity = calculateQuantity(frequency, e.target.value);
                  setValue(`medicine[${index}].Quantity`, quantity);
                  dataArray[index].Quantity = quantity;
                }
                clearErrors(`medicine[${index}].Duration`);
                setSelectedMedicines(dataArray);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  const nextField = document
                    .querySelector(`[name="medicine[${index}].Instructions"]`)
                    ?.closest(".w-full");
                  if (nextField) {
                    const selectInput = nextField.querySelector("input");
                    if (selectInput) {
                      selectInput.focus();
                      const selectDiv = nextField.querySelector(
                        ".css-1s2u09g-control",
                      );
                      if (selectDiv) {
                        selectDiv.click();
                      }
                    }
                  }
                }
              }}
            />
            <div className="px-3 rounded-full bg-[#073763] text-sm py-0.5 text-white">
              Days
            </div>
          </div>
        ) : null}

        {header === "Quantity" ? (
          <div className="flex justify-start w-full ml-2">
            <input
              className="h-7 w-20 border border-gray-400 rounded px-2"
              style={{ outline: "none" }}
              placeholder="Qty"
              name={`medicine[${index}].Quantity`}
              {...register(`medicine[${index}].Quantity`)}
              disabled={true}
              value={row?.Quantity}
            />
          </div>
        ) : null}

        {header === "Instructions" ? (
          <div className="flex justify-start ml-2 w-[20vw] xl:w-full">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              control={control}
              name={`medicine[${index}].Instructions`}
              // error={errors?.medicine?.[index]?.Instructions}
              placeholder={"Instructions"}
              handleInputChange={() => { }}
              inputRef={{
                ...register(`medicine[${index}].Instructions`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Instructions = e.target.value;
                    setSelectedMedicines(dataArray);
                    const nextField = document
                      .querySelector(`[name="medicine[${index}].Generic"]`)
                      ?.closest(".w-full");

                    if (nextField) {
                      const routeInput = nextField.querySelector("input");
                      if (routeInput) {
                        routeInput.focus();
                      }
                    }
                  },
                }),
              }}
              dataArray={medicineInstructions}
              isSearchable={true}
              isClearable={true}
            />
          </div>
        ) : null}

        {header === "Generic" ? (
          <div className="flex justify-start pl-2 w-[20vw] xl:w-full">
            <CustomCreateable
              control={control}
              name={`medicine[${index}].Generic`}
              error={errors?.medicine?.[index]?.Generic}
              isSearchable={true}
              placeholder={"Generic"}
              isClearable={true}
              handleInputChange={handleGetGenerics}
              inputRef={{
                ...register(`medicine[${index}].Generic`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Generic = e.target.value;
                    setSelectedMedicines(dataArray);
                    const nextField = document
                      .querySelector(`[name="medicine[${index}].Form"]`)
                      ?.closest(".w-full");

                    if (nextField) {
                      const routeInput = nextField.querySelector("input");
                      if (routeInput) {
                        routeInput.focus();
                      }
                    }
                  },
                }),
              }}
              dataArray={genericDrugs}
            />
          </div>
        ) : null}

        {header === "Form" ? (
          <div className="flex justify-start w-[18vw] xl:w-full ml-2">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              width={"170px"}
              control={control}
              name={`medicine[${index}].Form`}
              error={errors?.medicine?.[index]?.Form}
              placeholder={"Form"}
              handleInputChange={() => { }}
              inputRef={{
                ...register(`medicine[${index}].Form`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Form = e.target.value;
                    setSelectedMedicines(dataArray);
                  },
                }),
              }}
              dataArray={formOpt}
              isSearchable={true}
              isClearable={true}
            />
          </div>
        ) : null}
      </div>
    );
  };

  const renderActions = (row, index) => {
    return (
      <div className="flex items-center">
        <>
          {row?.Medicine !== "" ? (
            <div className="flex gap-2 cursor-pointer">
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    let dataArray = [...selectedMedicines];
                    if (dataArray[index].isNew === true) {
                      dataArray?.splice(index, 1);
                    } else if (dataArray[index].isNew === false) {
                      dataArray[index].isDeleted = true;
                    }
                    setSelectedMedicines([...dataArray]);
                  }}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <DeleteOutlineIcon fontSize="small" sx={{ color: "red" }} />
                </IconButton>
              </Tooltip>
            </div>
          ) : null}
        </>
      </div>
    );
  };

  // const handleSubmitEmr = () => {
  //   setIsPreview(false);
  //   trigger();

  //   const pastHistory = [];
  //   if (selectedHistory.length > 0) {
  //     for (let history of selectedHistory) {
  //       let pastHistoryObj = {
  //         historyDesc: history.label,
  //         since: history.since ? history.since : null,
  //         duration: history.duration,
  //         description: history.description,
  //       };
  //       pastHistory.push(pastHistoryObj);
  //     }
  //   }

  //   let familyHistory = [];

  //   if (selectedFamilyHistory.length > 0) {
  //     for (let history of selectedFamilyHistory) {
  //       let famHistoryObj = {
  //         historyDesc: history.label,
  //         since: history.since ? history.since : null,
  //         duration: history.duration,
  //         description: history.description,
  //       };
  //       familyHistory.push(famHistoryObj);
  //     }
  //   }

  //   const allergies = [];
  //   if (selectedAllergy.length > 0) {
  //     for (let aller of selectedAllergy) {
  //       let allerObj = {
  //         description: aller.label,
  //       };
  //       allergies.push(allerObj);
  //     }
  //   }

  //   const investigations = selectedInvestigations
  //     ? selectedInvestigations.map((inv) => ({
  //         serviceId: inv.testId ? inv.testId : 0,
  //         serviceName: inv.label,
  //       }))
  //     : [];

  //   const diagnosis = [];

  //   if (selectedDiagnosis.length > 0) {
  //     for (let diagno of selectedDiagnosis) {
  //       let diagnoDuration =
  //         diagno?.duration === "D"
  //           ? "Days"
  //           : diagno?.duration === "M"
  //           ? "Months"
  //           : diagno?.duration === "Y"
  //           ? "Years"
  //           : "";
  //       let diagnoObj = {
  //         description: diagno?.label,
  //         since: Number(diagno?.since) > 0 ? Number(diagno.since) : null,
  //         duration: diagno.since ? diagnoDuration : null,
  //       };
  //       diagnosis.push(diagnoObj);
  //     }
  //   }

  //   let advices = [];
  //   if (selectedAdvices.length > 0) {
  //     for (let adv of selectedAdvices) {
  //       let advObj = {
  //         description: adv.label,
  //       };
  //       advices.push(advObj);
  //     }
  //   }

  //   const otherReferrals = [];
  //   if (selectedOtherReferral.length > 0) {
  //     for (let ref of selectedOtherReferral) {
  //       let refObj = {
  //         id: ref?.id,
  //         description: ref?.label,
  //       };
  //       otherReferrals.push(refObj);
  //     }
  //   }

  //   const otherServicesData = otherServices
  //     ? otherServices.map((services) => ({
  //         serviceId: services?.id,
  //         serviceName: services?.label,
  //       }))
  //     : [];

  //   let medications = [];
  //   let filteredMedicines = selectedMedicines.filter(
  //     (medicine) => medicine?.Medicine !== ""
  //   );

  //   if (filteredMedicines?.length > 0) {
  //     for (let object of filteredMedicines) {
  //       let newMedicine = {
  //         id: object?.id ? object?.id : null,
  //         drugId: object?.Medicine?.id,
  //         drugName: object?.Medicine?.label,
  //         dosage: object?.Dosage,
  //         duration:
  //           Number(object?.Duration) > 0 ? Number(object?.Duration) : null,
  //         durationIn: "Days",
  //         formName: object?.Form?.label,
  //         formId: object.Form.Id ? object.Form.Id : null,
  //         frequencyName: object?.Frequency?.label,
  //         frequencyId: object?.Frequency?.id,
  //         genericName: object?.Generic?.label,
  //         genericId: object?.Generic?.id,
  //         instructionName: object?.Instructions?.label,
  //         instructionId: object?.Instructions?.Id,
  //         quantity: object?.Quantity,
  //         routeId: object?.Route.Id,
  //         routeName: object?.Route.label,
  //         isDelete: object?.isDeleted,
  //       };

  //       medications?.push(newMedicine);
  //     }
  //   }

  //   let oldMedications = [];
  //   if (oldMedicationsList?.length > 0) {
  //     for (let obj of oldMedicationsList?.filter(
  //       (val) => val?.Medicine !== null
  //     )) {
  //       let newOldMedicine = {
  //         id: obj?.id ? obj?.id : null,
  //         drugId: obj?.Medicine?.id,
  //         drugName: obj?.Medicine?.label,
  //         frequencyName: obj?.Frequency?.label,
  //         frequencyId: obj?.Frequency?.id,
  //         genericName: obj?.Generic?.label,
  //         genericId: obj?.Generic?.id,
  //         isDelete: obj?.isDelete,
  //         ison: obj?.ison === "On" ? true : false,
  //       };

  //       oldMedications?.push(newOldMedicine);
  //     }
  //   }

  //   let complaints = [];
  //   if (selectedComplaints.length > 0) {
  //     for (let complaint of selectedComplaints) {
  //       let complaintDuration =
  //         complaint?.duration === "D"
  //           ? "Days"
  //           : complaint?.duration === "M"
  //           ? "Months"
  //           : complaint?.duration === "Y"
  //           ? "Years"
  //           : "";

  //       let object = {
  //         complaint: complaint?.label,
  //         since: Number(complaint?.since) > 0 ? Number(complaint.since) : null,
  //         duration: complaint.since ? complaintDuration : null,
  //         description: complaint?.description,
  //       };
  //       complaints.push(object);
  //     }
  //   }

  //   let services = [];
  //   let servicesDataArray = [...selectedInvestigations, ...otherServices];
  //   for (let serTemp of servicesDataArray) {
  //     let serviceObj = {
  //       serviceMaster: {
  //         id: serTemp?.id,
  //       },
  //     };
  //     services.push(serviceObj);
  //   }

  //   const post = {
  //     id: emrId,
  //     doctorId: selectedRow?.["Doctor Id"],
  //     opdIpd: 0,
  //     opdIpdId: selectedRow?.VisitId,
  //     temp: temperatureWatch,
  //     bp: bpWatch,
  //     pulse: Number(pulseWatch),
  //     respiration: respirationWatch,
  //     spo2: spo2Watch,
  //     bsl: bslWatch,
  //     height: heightWatch,
  //     weight: weightWatch,
  //     bmi: Number(bmiWatch),
  //     importantNotes: impNotes,
  //     smoking: smokingWatch,
  //     tobacco: tobaccoWatch,
  //     alcohol: alcoholWatch,
  //     emrPastHistory: pastHistory,
  //     emrFamilyHistory: familyHistory,
  //     emrComplaints: complaints,
  //     emrAllergies: allergies,
  //     emrServices: services,
  //     emrDiagnosis: diagnosis,
  //     emrMedications: medications,
  //     emrOldMedications: oldMedications,
  //     emrAdvices: advices,
  //     emrOtherReferrals: otherReferrals,
  //     newFollowupDate: nextFollowupDate
  //       ? format(nextFollowupDate, "yyyy-MM-dd")
  //       : null,
  //   };
  //   console.log("postpost321", post);

  //   setPostObject(post);

  //   setOpenPost(true);
  // };

  const handleSubmitEmr = () => {
    // try {
    setIsPreview(false);
    // trigger();

    const mapHistory = (list = []) =>
      list.map((h) => ({
        historyDesc: h?.label,
        since: h?.since || null,
        duration: h?.duration,
        description: h?.description,
      }));

    const pastHistory = mapHistory(selectedHistory);
    const familyHistory = mapHistory(selectedFamilyHistory);

    const allergies = (selectedAllergy || []).map((a) => ({
      description: a?.label,
    }));

    const investigations = (selectedInvestigations || []).map((inv) => ({
      serviceId: inv?.testId || 0,
      serviceName: inv?.label,
    }));

    const diagnosis = (selectedDiagnosis || []).map((d) => {
      const durationMap = { D: "Days", M: "Months", Y: "Years" };
      return {
        description: d?.label,
        since: Number(d?.since) > 0 ? Number(d?.since) : null,
        duration: d?.since ? durationMap[d?.duration] : null,
      };
    });

    const advices = (selectedAdvices || []).map((a) => ({
      description: a?.label,
    }));

    const otherReferrals = (selectedOtherReferral || []).map((r) => ({
      id: r?.id,
      description: r?.label,
    }));

    const services = [
      ...(selectedInvestigations || []),
      ...(otherServices || []),
    ].map((s) => ({
      serviceMaster: s?.serviceMaster ? { id: s?.serviceMaster } : null,
      id: s.id ? s.id : null,
      description: s?.label,
    }));

    const medications = (selectedMedicines || [])
      .filter((m) => m?.Medicine !== "")
      .map((m) => ({
        id: m?.id || null,
        drugId: m?.Medicine?.id,
        drugName: m?.Medicine?.label,
        dosage: m?.Dosage,
        duration: Number(m?.Duration) > 0 ? Number(m?.Duration) : null,
        durationIn: "Days",
        formName: m?.Form?.label,
        formId: m?.Form?.Id ?? null,
        frequencyName: m?.Frequency?.id > 0 ? m?.Frequency?.label : null,
        frequencyId: m?.Frequency?.id > 0 ? m?.Frequency?.id : null,
        genericName: m?.Generic?.label,
        genericId: m?.Generic?.id,
        instructionName: m?.Instructions?.label,
        instructionId: m?.Instructions?.Id ?? null,
        quantity: m?.Quantity,
        routeId: m?.Route?.Id ?? null,
        routeName: m?.Route?.label,
        isDelete: m?.isDeleted,
      }));

    const oldMedications = (oldMedicationsList || [])
      .filter((o) => o?.Medicine)
      .map((o) => ({
        id: o?.id || null,
        drugId: o?.Medicine?.id,
        drugName: o?.Medicine?.label,
        frequencyName: o?.Frequency?.id > 0 && o?.Frequency?.label,
        frequencyId: o?.Frequency?.id > 0 && o?.Frequency?.id,
        genericName: o?.Generic?.label,
        genericId: o?.Generic?.id,
        isDelete: o?.isDelete,
        ison: o?.ison === "On",
      }));

    const complaints = (selectedComplaints || []).map((c) => {
      const durationMap = { D: "Days", M: "Months", Y: "Years" };
      return {
        complaint: c?.label,
        since: Number(c?.since) > 0 ? Number(c?.since) : null,
        duration: c?.since ? durationMap[c?.duration] : null,
        description: c?.description,
      };
    });

    const post = {
      id: emrId,
      doctorId: selectedRow?.["Doctor Id"],
      opdIpd: 0,
      opdIpdId:
        selectedVisitRow !== null && selectedVisitRow !== undefined
          ? selectedVisitRow?.opdIpdId
          : selectedRow?.VisitId,
      temp: Number(temperatureWatch),
      bp: Number(bpWatch),
      pulse: Number(pulseWatch),
      respiration: Number(respirationWatch),
      spo2: Number(spo2Watch),
      bsl: Number(bslWatch),
      height: Number(heightWatch),
      weight: Number(weightWatch),
      bmi: Number(bmiWatch),
      importantNotes: impNotes,
      smoking: smokingWatch === true ? true : false,
      tobacco: tobaccoWatch === true ? true : false,
      alcohol: alcoholWatch === true ? true : false,
      emrPastHistory: pastHistoryVal?.trim() || "",
      emrFamilyHistory: familyHistoryVal?.trim() || "",
      emrComplaints: complaintsVal?.trim() || "",
      emrAllergies: allergyVal?.trim() || "",
      emrServices: services || null,
      emrDiagnosis: diagnosis || null,
      emrMedications: medications || null,
      emrOldMedications: oldMedications || null,
      emrAdvices: advicesVal?.trim() || "",
      emrOtherReferrals: otherReferrals || null,
      newFollowupDate: nextFollowupDate
        ? format(nextFollowupDate, "yyyy-MM-dd")
        : null,
      // diet:
      //   selectedDiets?.length > 0
      //     ? selectedDiets?.map((val) => ({
      //       id: val?.id ? val?.id : null,
      //       dietId: val?.dietId ? val?.dietId : null,
      //       description: val?.description,
      //     }))
      //     : null,
      diet: dietExericesVal?.trim() || "",
      hopi: getHopi?.trim() || "",
      rs: getRS !== "" ? getRS : "",
      cvs: getCVS !== "" ? getCVS : "",
      cns: getCNS !== "" ? getCNS : "",
      pa: getPA !== "" ? getPA : "",
      seOther: getOther !== "" ? getOther : "",
      generalExaminations:
        getGeneralExaminations !== "" ? selectedGeneralExam : "",
      reviewOfLab: getReviewOfLab !== "" ? getReviewOfLab : "",
    };

    console.log("EMR POST:", post);

    setPostObject(post);
    setOpenPost(true);
    // } catch (error) {
    //   console.error("handleSubmitEmr crashed:", error);
    //   setOpenPost(true);
    // }
  };

  const handleResetMedicines = () => {
    // let dataArray = [];
    // for (let object of medicinesData) {
    //   object.Medicine = "";
    //   object.since = "";
    //   object.Generic = "";
    //   object.Frequency = "";
    //   object.Dosage = "";
    //   object.Quantity = "";
    //   object.Days = "";
    //   object.Instructions = "";
    //   object.Route = "";
    //   object.Form = "";
    //   object.isDeleted = false;
    //   dataArray.push(object);
    // }
    setSelectedMedicines(medicinesData);
  };
  const handleResetAll = () => {
    reset(defaultValues);
    setSelectedHistory([]);
    setSelectedFamilyHistory([]);
    setSelectedComplaints([]);
    setSelectedAllergy([]);
    setSelectedDiagnosis([]);
    setSelectedInvestigations([]);
    handleResetMedicines();
    setOtherServices([]);
    setSelectedLocalAdvices([]);
  };

  const postEmr = () => {
    setOpenBackdrop(true);
    console.log("saveEMRsaveEMRsaveEMR", postObject);

    saveEMR(postObject, false)
      .then((response) => response.data)
      .then((res) => {
        setOpenBackdrop(false);
        successAlert(res?.message);
        setOpenPost(false);
        // getPreviousDetails({
        //   opdIpdId: selectedRow?.VisitId,
        //   patientId: 0,
        // });
        // close();
        // handleResetAll();
      })
      .catch((err) => {
        setOpenBackdrop(false);
        errorAlert(err?.message);
      });
  };

  const updateEmr = () => {
    setOpenBackdrop(true);
    updateEMR(postObject)
      .then((response) => response.data)
      .then((res) => {
        setOpenBackdrop(false);
        successAlert(res?.message);
        setOpenPost(false);
        // getPreviousDetails({
        //   opdIpdId: selectedRow?.VisitId,
        //   patientId: 0,
        // });
        // close();
        // handleResetAll();
      })
      .catch((err) => {
        setOpenBackdrop(false);
        errorAlert(err?.message);
      });
  };

  const handleSearchPastHistory = (searchString) => {
    if (searchString !== "" && UseCheckConsecutiveCharacters(searchString)) {
      getPastHistoryAutoSearch(searchString).then((response) => {
        if (response?.data?.statusCode === 200) {
          setPastHistoryOptions(response?.data?.result);
        }
      });
    }
  };

  const handleSearchComplaints = (search) => {
    if (search !== "") {
      getComplaintsData(search)
        .then((response) => response.data)
        .then((res) => {
          if (res?.statusCode === 200) {
            setComplaintsOptions(res?.result);
          }
        })
        .catch((er) => er);
    }
  };

  const handleSearchAllergies = (search) => {
    if (search !== "") {
      getAllergiesData(search)
        .then((response) => response.data)
        .then((res) => {
          if (res?.statusCode === 200) {
            setAllergyOption(res?.result);
          }
        })
        .catch((er) => er);
    }
  };

  const handleSearchInvestigations = (search) => {
    if (search !== "") {
      getInvestigations(search, 2)
        .then((response) => response.data)
        .then((res) => {
          if (res?.statusCode === 200) {
            setInvOptions(res?.result);
          }
        })
        .catch((er) => er);
    }
  };

  const handelSearchDiagnosis = (search) => {
    if (search !== "") {
      getDiagnosis(
        search,
        loggedUser?.loginUnitId,
        location?.state?.departmentId,
      )
        .then((response) => response.data)
        .then((res) => {
          setDiagnoOptions(res?.result);
        })
        .catch((er) => er);
    }
  };

  const handleOtherReferral = (search) => {
    if (search !== "") {
      getReferenceDoctor(
        search,
        loggedUser?.loginUnitId,
        location?.state?.departmentId,
      )
        .then((response) => response.data)
        .then((res) => {
          setReferralDocOptions(res?.result);
        })
        .catch((er) => er);
    }
  };

  const handleSearchServices = (search) => {
    if (search !== "") {
      getOtherServices(search)
        .then((response) => response.data)
        .then((res) => {
          setServicesOptions(res?.result);
        })
        .catch((err) => err);
    }
  };

  const handleSearchAdvices = (search) => { };
  const handleSearchDiets = (search) => { };

  const handleAddDuration = (duration, historyIndex) => {
    let dataArray = [...selectedHistory];
    dataArray[historyIndex].duration = duration;
    setSelectedHistory(dataArray);
  };

  const handleAddFamilyHistoryDuration = (duration, familyIndex) => {
    let dataArray = [...selectedFamilyHistory];
    dataArray[familyIndex].duration = duration;
    setSelectedFamilyHistory(dataArray);
  };

  const handleAddComplaintsDuration = (duration, complaintIndex) => {
    let dataArray = [...complaints, ...selectedComplaints];

    dataArray[complaintIndex].duration = duration;
    setComplaints(dataArray);
  };

  const handleAddDiagnosisDuration = (duration, diagnosisIndex) => {
    let dataArray = [...diagnosis, ...selectedDiagnosis];

    dataArray[diagnosisIndex].duration = duration;
    setDiagnosis(dataArray);
  };

  const calculateFutureDate = (dateString, maxDays) => {
    const [day, month, year] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + maxDays);
    const dayOfWeek = date.getDay();
    if (dayOfWeek === 0) {
      date.setDate(date.getDate() - 1);
    }
    const newDay = date.getDate().toString().padStart(2, "0");
    const newMonth = (date.getMonth() + 1).toString().padStart(2, "0");
    const newYear = date.getFullYear();

    return `${newDay}-${newMonth}-${newYear}`;
  };

  const caclulateFollowupAfterDate = (duration, currentDate, type) => {
    if (!duration || duration <= 0) {
      setValue("nextFollowupDate", null);
      setIsFollowupDateValid(true);
      return;
    }

    const today = new Date(currentDate);
    const calculatedDate = new Date(currentDate);

    if (type === "D") {
      calculatedDate.setDate(calculatedDate.getDate() + duration);
    } else if (type === "M") {
      calculatedDate.setMonth(calculatedDate.getMonth() + duration);
    }

    // Auto-select D/M
    if (
      calculatedDate.getMonth() === today.getMonth() &&
      calculatedDate.getFullYear() === today.getFullYear()
    ) {
      setFollowupAfterValue("D");
    } else {
      setFollowupAfterValue("M");
    }

    // Sunday validation
    if (calculatedDate.getDay() === 0) {
      // errorAlert("This is Sunday. Follow-up is not allowed on this day.");
      setValue("nextFollowupDate", calculatedDate);
      setIsFollowupDateValid(false);
      return;
    }

    setValue("nextFollowupDate", calculatedDate);
    setIsFollowupDateValid(true);
  };

  const focusOnFields = (type) => {
    if (type === "complaint") {
      let fieldsetTag = complaintFocusRef.current;
      let inputTagCollection = fieldsetTag?.getElementsByTagName("input");
      let inputTagOne = inputTagCollection[0];
      inputTagOne.focus();
    } else if (type === "allergy") {
      let fieldsetTag = allergyFocusRef.current;
      let inputTagCollection = fieldsetTag?.getElementsByTagName("input");
      let inputTagOne = inputTagCollection[0];
      inputTagOne.focus();
    } else if (type === "investgation") {
      let fieldsetTag = investigationFocusRef.current;
      let inputTagCollection = fieldsetTag?.getElementsByTagName("input");
      let inputTagOne = inputTagCollection[0];
      inputTagOne.focus();
    } else if (type === "diagnosis") {
      let fieldsetTag = diagnosisFocusRef.current;
      let inputTagCollection = fieldsetTag?.getElementsByTagName("input");
      let inputTagOne = inputTagCollection[0];
      inputTagOne.focus();
    } else if (type === "advices") {
      let fieldsetTag = advicesFocusRef.current;
      let inputTagCollection = fieldsetTag?.getElementsByTagName("input");
      let inputTagOne = inputTagCollection[0];
      inputTagOne.focus();
    } else if (type === "otherReferral") {
      let fieldsetTag = otherReferralFocusRef.current;
      let inputTagCollection = fieldsetTag?.getElementsByTagName("input");
      let inputTagOne = inputTagCollection[0];
      inputTagOne.focus();
    } else if (type === "otherServices") {
      let fieldsetTag = otherServicesFocusRef.current;
      let inputTagCollection = fieldsetTag?.getElementsByTagName("input");
      let inputTagOne = inputTagCollection[0];
      inputTagOne.focus();
    }
  };

  const copyPatientPrescription = () => {
    const userInfomation = JSON.parse(localStorage?.getItem("userInfo"))
    getPatientLastMedications(selectedRow?.PatientId, userInfomation?.doctorId)
      .then((response) => {
        let templateMedicineData = response?.data?.result;

        let updatedMedicines = [...selectedMedicines];
        for (let i = 0; i < templateMedicineData.length; i++) {
          const medicine = templateMedicineData[i];

          const medicineObj = {
            Medicine: {
              id: medicine?.drug_id,
              label: medicine?.drug_name,
              value: medicine?.drug_name,
              Medicine: medicine?.drug_name,
            },
            Dosage: "",
            Frequency: {
              id: medicine?.frequency_id,
              label: medicine?.frequency_name,
              value: medicine?.frequency_name,
            },
            Route: {
              Id: medicine?.route_id,
              label: medicine?.route_name,
              value: medicine?.route_name,
            },
            Duration: "",
            Quantity: "",
            Instructions: null,
            Generic: {
              id: medicine?.generic_id,
              label: medicine?.generic_name,
              value: medicine?.generic_name,
            },
            Form: null,
            isDeleted: false,
            since: "",
          };
          updatedMedicines[i] = medicineObj;
          setValue(`medicine[${i}].Medicine`, medicineObj.Medicine);
          setValue(`medicine[${i}].Dosage`, medicine?.Dosage);
          setValue(`medicine[${i}].Frequency`, medicineObj.Frequency);
          setValue(`medicine[${i}].Route`, medicineObj.Route);
          setValue(`medicine[${i}].Duration`, medicineObj?.Duration);
          setValue(`medicine[${i}].Quantity`, medicineObj?.Quantity);
          setValue(`medicine[${i}].Instructions`, medicineObj.Instructions);
          setValue(`medicine[${i}].Generic`, medicineObj.Generic);
          setValue(`medicine[${i}].Form`, medicineObj.Form);
        }

        setSelectedMedicines([...updatedMedicines, ...medicinesData]);
      })
      .catch((err) => err);
  };

  React.useEffect(() => {
    let filterdComplaints = selectedComplaints.filter(
      (list) => list.label === complaintWatch?.label,
    );

    if (editComplaintIndex === null) {
      if (
        complaintWatch !== null &&
        complaintWatch !== undefined &&
        filterdComplaints?.length > 0
      ) {
        errorAlert("Complaint Already Exist..!");
        setValue("createComplaint", null);
      } else {
        if (complaintWatch !== null && complaintWatch !== undefined) {
          let combinedComplaints = [...selectedComplaints];

          if (complaintWatch && complaintWatch.label) {
            combinedComplaints.push({
              id: complaintWatch?.__isNew__ === true ? null : complaintWatch.id,
              label: complaintWatch.label,
              value: complaintWatch.value || null,
              since: "",
              duration: "D",
              description: "",
              isChecked: true,
            });
          }

          combinedComplaints = combinedComplaints.filter(
            (item) => item.label && item.isChecked,
          );

          const uniqueArray = Array.from(
            new Map(
              combinedComplaints.map((item) => [item.label, item]),
            ).values(),
          ).sort((a, b) => {
            if (a.value === null) return 1;
            if (b.value === null) return -1;
            return a.value - b.value;
          });

          setComplaints(uniqueArray);
          setSelectedComplaints(uniqueArray);
          setValue("createComplaint", null);
          focusOnFields("complaint");
        } else {
          let dataArray = [...selectedComplaints, ...complaints];
          for (let object of dataArray) {
            if (object?.label === complaintWatch?.label) {
              object.isChecked = true;
            }
            setComplaints(dataArray);
            setValue("createComplaint", null);
            focusOnFields("complaint");
          }
        }
        setResetComplaints(resetComplaints + 1);
      }
    }
  }, [complaintWatch]);

  React.useEffect(() => {
    // if (allergyWatch !== null && allergyWatch !== undefined) {
    //   findNextAllergic();
    // }
    if (allergyWatch) {
      let dataArray = [...selectedAllergy];
      let allergy = allergyWatch;

      const filteredAllergy = dataArray.filter(
        (list) => list.value === allergy.value,
      );

      if (filteredAllergy.length > 0) {
        errorAlert("Allergy Already Exist!");
        setValue("searchAllergy", null);
      } else if (allergyWatch !== undefined) {
        let allergyObject = {
          id: allergyWatch?.id,
          label: allergyWatch.label,
          value: allergyWatch.value,
        };

        dataArray.push(allergyObject);
        setValue("searchAllergy", null);
        setSelectedAllergy(dataArray);
      }
      focusOnFields("allergy");
    }
  }, [allergyWatch]);

  React.useEffect(() => {
    if (diagnosisWatch) {
      let dataArray = [...selectedDiagnosis];
      let diagno = diagnosisWatch;

      const filterdDiagnosis = dataArray.filter(
        (list) => list.value === diagno.value,
      );

      if (filterdDiagnosis.length > 0) {
        errorAlert("Diagnosis Already Exist!");
      } else {
        diagno.isChecked = true;
        dataArray.push(diagno);

        const combinedComplaints = dataArray.filter(
          (item) => item.label && item.isChecked,
        );

        const uniqueDiagnosis = Array.from(
          new Map(
            combinedComplaints.map((item) => [item.label, item]),
          ).values(),
        ).sort((a, b) => {
          if (a.value === null) return 1;
          if (b.value === null) return -1;
          return a.value - b.value;
        });

        setSelectedDiagnosis(uniqueDiagnosis);

        const previousDiagnosis = [...diagnosis];
        const mergedDiagnosis = [
          ...new Map(
            [...previousDiagnosis, ...combinedComplaints].map((item) => [
              item.label,
              item,
            ]),
          ).values(),
        ];

        setDiagnosis(mergedDiagnosis);
      }

      setValue("searchDiagnosis", null);
      focusOnFields("diagnosis");
    }
  }, [diagnosisWatch, selectedDiagnosis]);

  React.useEffect(() => {
    if (investigationWatch) {
      let dataArray = [...selectedInvestigations];
      let filtered = dataArray.filter(
        (inv) => inv.label === investigationWatch?.label,
      );
      if (filtered.length > 0 && investigationWatch !== null) {
        errorAlert("Investigation Already Exist");
        setValue("searchInvestigations", null);
      } else if (investigationWatch?.label !== undefined) {
        let investigationObject = {
          id: null,
          serviceMaster: investigationWatch?.ServiceId
            ? investigationWatch?.ServiceId
            : null,
          label: investigationWatch?.label,
          value: investigationWatch?.value,
        };

        dataArray.push(investigationObject);

        let tempArr = selectedInvestigations.filter(
          (list) => list.testId !== undefined && list.serviceId !== undefined,
        );

        setValue("searchInvestigations", null);
        setSelectedInvestigations(dataArray);
      }
      focusOnFields("investgation");
    }
  }, [investigationWatch]);

  React.useEffect(() => {
    if (otherReferralWatch) {
      let dataArray = [...selectedOtherReferral];
      let otherReferral = otherReferralWatch;

      const filteredAllergy = dataArray.filter(
        (list) => list.value === otherReferral.value,
      );

      if (filteredAllergy.length > 0) {
        errorAlert("Doctor Already Exist!");
        setValue("referralDoctor", null);
      } else if (otherReferralWatch !== undefined) {
        let otherReferralObject = {
          id: otherReferralWatch.id,
          label: otherReferralWatch.label,
          value: otherReferralWatch.value,
        };

        dataArray.push(otherReferralObject);
        setValue("referralDoctor", null);
        setSelectedOtherReferral(dataArray);
      }
      focusOnFields("otherReferral");
    }
  }, [otherReferralWatch]);

  React.useEffect(() => {
    if (advicesWatch) {
      let dataArray = [...selectedAdvices];
      let advices = advicesWatch;

      const filteredAllergy = dataArray.filter(
        (list) => list.value === advices.value,
      );

      if (filteredAllergy.length > 0) {
        errorAlert("Advice Already Exist!");
        setValue("searchAdvices", null);
      } else if (advicesWatch !== undefined) {
        let otherReferralObject = {
          id: advicesWatch?.id,
          label: advicesWatch.label,
          value: advicesWatch.value,
        };

        dataArray.push(otherReferralObject);
        setValue("searchAdvices", null);
        setSelectedAdvices(dataArray);
      }
      focusOnFields("advices");
    }
  }, [advicesWatch]);

  React.useEffect(() => {
    if (watchOtherServices) {
      let dataArray = [...otherServices];
      let otherService = watchOtherServices;

      const filteredAllergy = dataArray.filter(
        (list) => list.value === otherService.value,
      );

      if (filteredAllergy.length > 0) {
        errorAlert("Service Already Exist!");
        setValue("searchOtherServices", null);
      } else if (watchOtherServices !== undefined) {
        let otherServicesObj = {
          id: null,
          serviceMaster: watchOtherServices.id ? watchOtherServices.id : null,
          label: watchOtherServices.label,
          value: watchOtherServices.value,
        };

        dataArray.push(otherServicesObj);
        setValue("searchOtherServices", null);
        setOtherServices(dataArray);
      }
      focusOnFields("otherServices");
    }
  }, [watchOtherServices]);

  // React.useEffect(() => {
  //   if (watchEMRTemplateValue !== null) {
  //     emrTemplateEditData(watchEMRTemplateValue.id)
  //       .then((response) => response.data)
  //       .then((res) => {
  //         if (res?.result) {
  //           let dataArray = res?.result[0];

  //           let complaint = JSON.parse(dataArray?.emrComplaints || "[]");
  //           let templateComplaint = [];

  //           if (complaint?.length > 0) {
  //             for (let comp of complaint) {
  //               let complaintObj = {
  //                 id: comp?.id,
  //                 label: comp?.description,
  //                 value: comp?.description,
  //                 isChecked: true,
  //               };

  //               templateComplaint.push(complaintObj);
  //               setSelectedComplaints(templateComplaint);
  //             }
  //           }
  //           let services = JSON.parse(dataArray?.emrServices || "[]");
  //           let selectedInvestigations = [];
  //           let otherServices = [];

  //           if (services.length > 0) {
  //             for (let serv of services) {
  //               let serviceObj = {
  //                 id: serv?.id,
  //                 label: serv?.Label,
  //                 value: serv?.Label,
  //                 groupId: serv?.GroupId,
  //               };

  //               if (serviceObj.groupId === 2 || serviceObj.groupId === 32) {
  //                 selectedInvestigations.push(serviceObj);
  //               } else {
  //                 otherServices.push(serviceObj);
  //               }
  //             }

  //             setSelectedInvestigations(selectedInvestigations);
  //             setOtherServices(otherServices);
  //           }
  //           let daignosis = JSON.parse(dataArray?.emrDiagnosis || "[]");
  //           let editDiagnosis = [];
  //           if (daignosis?.length > 0) {
  //             for (let diagno of daignosis) {
  //               let diagnosisObj = {
  //                 id: diagno?.id,
  //                 label: diagno?.diagnosis,

  //                 isChecked: true,
  //               };
  //               editDiagnosis.push(diagnosisObj);
  //               setSelectedDiagnosis(editDiagnosis);
  //             }
  //           }
  //           let medications = JSON.parse(dataArray?.emrItems || "[]");
  //           if (medications.length > 0) {
  //             for (let i = 0; i < medications.length; i++) {
  //               let medicationObj = {
  //                 Medicine: {
  //                   id: medications[i]?.item_id,
  //                   label: medications[i]?.item_name,
  //                   value: medications[i]?.item_id,
  //                   Medicine: medications[i]?.item_name,
  //                 },
  //                 Dosage: medications[i]?.dosage,
  //                 Frequency: {
  //                   id: medications[i]?.frequency_id,
  //                   label: medications[i]?.frequency_name,
  //                   value: medications[i]?.frequency_id,
  //                 },
  //                 Route: {
  //                   Id: medications[i]?.route_id,
  //                   label: medications[i]?.route_name,
  //                   value: medications[i]?.route_id,
  //                 },
  //                 Duration: medications[i]?.duration,
  //                 Quantity: medications[i]?.quantity,
  //                 Instructions: {
  //                   id: medications[i]?.instruction_id,
  //                   label: medications[i]?.instruction_name,
  //                   value: medications[i]?.instruction_id,
  //                 },
  //                 Generic: {
  //                   id: medications[i]?.generic_id,
  //                   label: medications[i]?.generic_name,
  //                   value: medications[i]?.generic_id,
  //                 },
  //                 Form: {
  //                   Id: medications[i]?.form_id,
  //                   label: medications[i]?.form_name,
  //                   value: medications[i]?.form_id,
  //                 },
  //                 isDeleted: false,
  //               };

  //               if (medicationObj?.Medicine?.Medicine !== "") {
  //                 let dataArray = selectedMedicines;
  //                 dataArray.splice(i, 1, medicationObj);
  //                 setSelectedMedicines(dataArray);
  //               }

  //               setValue(`medicine[${i}].Quantity`, medicationObj.Quantity);
  //               setValue(
  //                 `medicine[${i}].Instructions`,
  //                 medicationObj.Instructions
  //               );

  //               setValue(`medicine[${i}].Form`, medicationObj.Form);

  //               setValue(`medicine[${i}].Generic`, medicationObj.Generic);
  //             }
  //           } else {
  //             handleResetMedicines();
  //           }

  //           let advices = JSON.parse(dataArray?.emrAdvices);
  //           let editAdvice = [];

  //           if (advices.length > 0) {
  //             for (let adv of advices) {
  //               let adviceObj = {
  //                 id: adv?.id,
  //                 label: adv?.advice,
  //                 value: adv?.advices,
  //               };
  //               editAdvice.push(adviceObj);
  //               setSelectedAdvices(editAdvice);
  //             }
  //           }
  //         }
  //       })
  //       .catch((error) => error);
  //   }
  // }, [watchEMRTemplateValue]);

  const handleRowSelect = (tempId) => {
    setSelectedEMRTemplate(tempId);
    if (tempId !== null) {
      emrTemplateEditData(tempId)
        .then((response) => response.data)
        .then((res) => {
          if (res?.result.length > 0) {
            let dataArray = res?.result[0];

            let complaint = JSON.parse(dataArray?.emrComplaints || "[]");
            let templateComplaint = [];

            if (complaint?.length > 0) {
              for (let comp of complaint) {
                let complaintObj = {
                  id: comp?.id,
                  label: comp?.description,
                  value: comp?.description,
                  since: "",
                  duration: "",
                  description: "",
                  isChecked: true,
                };

                templateComplaint.push(complaintObj);
                setSelectedComplaints(templateComplaint);
              }
            }
            let services = JSON.parse(dataArray?.emrServices || "[]");
            let selectedInvestigations = [];
            let otherServices = [];

            if (services.length > 0) {
              for (let serv of services) {
                let serviceObj = {
                  id: serv?.id,
                  label: serv?.Label,
                  value: serv?.Label,
                  groupId: serv?.GroupId,
                };

                if (serviceObj.groupId === 2 || serviceObj.groupId === 32) {
                  selectedInvestigations.push(serviceObj);
                } else {
                  otherServices.push(serviceObj);
                }
              }

              setSelectedInvestigations(selectedInvestigations);
              setOtherServices(otherServices);
            }
            let daignosis = JSON.parse(dataArray?.emrDiagnosis || "[]");
            let editDiagnosis = [];
            if (daignosis?.length > 0) {
              for (let diagno of daignosis) {
                let diagnosisObj = {
                  id: diagno?.id,
                  label: diagno?.diagnosis,
                  since: "",
                  duration: "",
                  isChecked: true,
                };
                editDiagnosis.push(diagnosisObj);
                setSelectedDiagnosis(editDiagnosis);
              }
            }
            let medications = JSON.parse(dataArray?.emrItems || "[]");
            if (medications.length > 0) {
              for (let i = 0; i < medications.length; i++) {
                let medicationObj = {
                  Medicine: {
                    id: medications[i]?.item_id,
                    label: medications[i]?.item_name,
                    value: medications[i]?.item_id,
                    Medicine: medications[i]?.item_name,
                  },
                  Dosage: medications[i]?.dosage,
                  Frequency: {
                    id: medications[i]?.frequency_id,
                    label: medications[i]?.frequency_name,
                    value: medications[i]?.frequency_id,
                  },
                  Route: {
                    Id: medications[i]?.route_id,
                    label: medications[i]?.route_name,
                    value: medications[i]?.route_id,
                  },
                  Duration: medications[i]?.duration,
                  Quantity: medications[i]?.quantity,
                  Instructions: {
                    id: medications[i]?.instruction_id,
                    label: medications[i]?.instruction_name,
                    value: medications[i]?.instruction_id,
                  },
                  Generic: {
                    id: medications[i]?.generic_id,
                    label: medications[i]?.generic_name,
                    value: medications[i]?.generic_id,
                  },
                  Form: {
                    Id: medications[i]?.form_id,
                    label: medications[i]?.form_name,
                    value: medications[i]?.form_id,
                  },
                  isDeleted: false,
                };

                if (medicationObj?.Medicine?.Medicine !== "") {
                  let dataArray = selectedMedicines;
                  dataArray.splice(i, 1, medicationObj);
                  setSelectedMedicines(dataArray);
                }

                setValue(`medicine[${i}].Quantity`, medicationObj.Quantity);
                setValue(
                  `medicine[${i}].Instructions`,
                  medicationObj.Instructions,
                );

                setValue(`medicine[${i}].Form`, medicationObj.Form);

                setValue(`medicine[${i}].Generic`, medicationObj.Generic);
              }
            } else {
              handleResetMedicines();
            }

            let advices = JSON.parse(dataArray?.emrAdvices);
            let editAdvice = [];

            if (advices.length > 0) {
              for (let adv of advices) {
                let adviceObj = {
                  id: adv?.id,
                  label: adv?.advice,
                  value: adv?.advices,
                };
                editAdvice.push(adviceObj);
                setSelectedAdvices(editAdvice);
              }
            }
          } else {
            handleResetAll();
          }
        })
        .catch((error) => error);
    }
  };

  const emrConsultation = () => {
    setOpenBackdrop(true);
    setStartConsultation(false);
    if (selectedRow?.VisitId) {
      startEMRConsultation(selectedRow?.VisitId)
        .then((response) => {
          successAlert(response?.data?.message);
          setOpenBackdrop(false);
        })
        .catch((error) => {
          setOpenBackdrop(false);
          errorAlert(error?.data?.result?.message || error?.message);
        });
    }
  };

  console.log("selectedRow321", selectedRow);

  console.log("selectedMedicines321", selectedMedicines);
  const handleTemplateOnSubmit = (selectedField) => {
    const obj = {
      templateName: "templateName",
      templateFieldId: selectedFieldId || selectedField ? selectedFieldId || selectedField : null,
      description:
        selectedFieldId === 4
          ? selectedHopis
          : selectedFieldId === 3
            ? selectedGeneralExam
            : "",
      doctorId: selectedRow?.["Doctor Id"] ? selectedRow?.["Doctor Id"] : null,
      // id: selectedId !== null ? selectedId : null,
      id: null,

    };
    setOpenBackdrop(true);

    console.log(obj, "obj");
    saveTemplateMaster(obj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          setOpenModal(false);
          // populateTable();
          successAlert(res?.message);
          reset();
          setOpenBackdrop(false);
          setSelectedFieldId(null);
        }
      })
      .catch((error) => {
        // console.log("error", error);
        setOpenModal(false);
        errorAlert(error?.message);
        setOpenBackdrop(false);
      });
  };

  useEffect(() => {
    setSelectedHopis(getHopi);
  }, [getHopi]);
  return (
    <div>
      <Modal
        open={openEmrModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyles} className="h-[95%]  py-4">
          <div className="px-2">
            <div className="flex justify-between mb-4">
              <div className="flex justify-between w-full">
                <div className="flex justify-center font-bold text-xl my-2 px-3">
                  EMR
                </div>
                <div className="flex space-x-5 mr-10">
                  <CommonButton
                    type="button"
                    label="Current Visit"
                    className="bg-customBlue text-white"
                    onClick={() => {
                      // getPreviousDetails({
                      //   opdIpdId: selectedRow?.VisitId,
                      //   patientId: 0,
                      // });
                      setVisitIndex(null);
                      setSelectedVisitRow(null);
                    }}
                  />
                  <CommonButton
                    type="button"
                    label="Prev. History"
                    className="bg-customBlue text-white mr-10"
                    disabled={emrId > 0}
                    onClick={() => {
                      getPreviousDetails({
                        opdIpdId: selectedRow?.VisitId,
                        patientId: selectedRow?.PatientId,
                      });
                      setVisitIndex(null);
                      setSelectedVisitRow(null);
                    }}
                  />
                </div>
              </div>
              <div className="flex ">
                <button
                  onClick={() => {
                    close();
                    handleResetAll();
                    setSelectedVisitRow(null);
                  }}
                  type="button"
                >
                  <CancelPresentationIconButton />
                </button>
              </div>
            </div>
            <div className="grid grid-cols-2 2xl:grid-cols-4 gap-2 items-center">
              <div className="bg-[#F1F1F1] p-2 whitespace-nowrap w-full col-span-2 grid grid-cols-3 lg:grid-cols-4 justify-start items-center lg:h-9">
                <div className="xl:w-[30%] flex justify-start font-semibold">
                  MRNo :&nbsp;
                  <span className="text-purple-800 px-2">
                    {/* {location?.state?.mrno} */}
                    {selectedRow?.MRNo}
                  </span>
                </div>
                <div className="xl:w-[40%] flex justify-start font-semibold md:col-span-2">
                  Patient Name :&nbsp;
                  <span className="text-purple-800 px-2">
                    {/* {location?.state?.patientName} */}
                    {selectedRow?.["Patient Name"]}
                  </span>
                </div>
                <div className=" flex justify-start font-semibold">
                  Age / Gender :&nbsp;
                  <span className="text-purple-800 px-2">
                    {/* {location?.state?.age} */}
                    {selectedRow?.AgeYear}
                    /&nbsp;
                    {/* {location?.state?.Gender?.charAt(0)} */}
                    {selectedRow?.Gender}
                  </span>
                </div>
              </div>
              <div className="col-span-2 grid md:grid-cols-3 xl:grid-cols-9 gap-2">
                <div>
                  <InputField
                    control={control}
                    name="temperature"
                    label="Temp °F"
                    type="number"
                    error={errors.temperature}
                    inputRef={{
                      ...register("temperature", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 200) {
                            setError("temperature", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("temperature");
                          }
                        },
                      }),
                    }}
                  />
                </div>

                <div>
                  <InputField
                    control={control}
                    name="bp"
                    error={errors?.bp}
                    // type="number"
                    label="BP mmHg"
                    inputRef={{
                      ...register("bp", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 500) {
                            setError("bp", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("bp ");
                          }
                        },
                      }),
                    }}
                  />
                </div>

                <div>
                  <InputField
                    control={control}
                    name="pulse"
                    label="Pulse/min"
                    error={errors.pulse}
                    type="number"
                    inputRef={{
                      ...register("pulse", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 220) {
                            setError("pulse", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("pulse");
                          }
                        },
                      }),
                    }}
                  />
                </div>

                <div>
                  <InputField
                    control={control}
                    name="respiration"
                    label={"Respiration"}
                    type={"number"}
                    error={errors.respiration}
                    inputRef={{
                      ...register("respiration", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 100) {
                            setError("respiration", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("respiration");
                          }
                        },
                      }),
                    }}
                  />
                </div>

                <div>
                  <InputField
                    control={control}
                    name="spo2"
                    label="SpO2 %"
                    type="number"
                    error={errors.spo2}
                    inputRef={{
                      ...register("spo2", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 200) {
                            setError("spo2", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("spo2");
                          }
                        },
                      }),
                    }}
                  />
                </div>

                <div>
                  <InputField
                    control={control}
                    name="bsl"
                    label={"BSL"}
                    type="number"
                    error={errors?.bsl}
                    inputRef={{
                      ...register("bsl", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 300) {
                            setError("bsl", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("bsl");
                          }
                        },
                      }),
                    }}
                  />
                </div>

                <div>
                  <InputField
                    control={control}
                    name="height"
                    label="Height (cms)"
                    error={errors.height}
                    type="number"
                    inputRef={{
                      ...register("height", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 300) {
                            setError("height", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("height");
                          }
                        },
                      }),
                    }}
                  />
                </div>
                <div>
                  <InputField
                    control={control}
                    name="weight"
                    label="Weight (kg)"
                    type="number"
                    error={errors.weight}
                    inputRef={{
                      ...register("weight", {
                        onChange: (e) => {
                          if (Number(e.target.value) > 300) {
                            setError("weight", {
                              type: "custom",
                              message: "Required",
                            });
                          } else {
                            clearErrors("weight ");
                          }
                        },
                      }),
                    }}
                  />
                </div>
                <div>
                  <InputField
                    control={control}
                    name="bmi"
                    label="BMI"
                    disabled={true}
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div className="flex gap-2  pt-8">


              <div
                className={`-mt-8 rounded px-2  h-[700px]`}
              >
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2 ">
                  <div className="shadow-lg col-span-2 lg:col-span-1 shadow-slate-300 rounded px-2">
                    <div>
                      <div className="flex gap-1 py-1">
                        {/* <Tooltip title="Create">
                          <IconButton
                            sx={{
                              ...iconButtonStyle,
                              bgcolor: "#dcfce7",
                              color: "#166534",
                              "&:hover": { bgcolor: "#bbf7d0" },
                            }}
                          >
                            <CiSquarePlus size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Edit">
                          <IconButton
                            sx={{
                              ...iconButtonStyle,
                              bgcolor: "#dbeafe",
                              color: "#1e3a8a",
                              "&:hover": { bgcolor: "#bfdbfe" },
                            }}
                          >
                            <CiEdit size={16} />
                          </IconButton>
                        </Tooltip> */}

                        <Tooltip title="Past History">
                          <IconButton
                            sx={{
                              ...iconButtonStyle,
                              bgcolor: "#ede9fe",
                              color: "#4c1d95",
                              "&:hover": { bgcolor: "#ddd6fe" },
                            }}
                            onClick={loadEmrImpNotes}
                          >
                            <GoHistory size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Clear">
                          <IconButton
                            sx={{
                              ...iconButtonStyle,
                              bgcolor: "#fee2e2",
                              color: "#7f1d1d",
                              "&:hover": { bgcolor: "#fecaca" },
                            }}
                            onClick={() => {
                              setImpNotes("")
                            }}
                          >
                            <RxReset size={16} />
                          </IconButton>
                        </Tooltip>
                      </div>
                      <TextareaAutosize
                        value={impNotes}
                        placeholder="Quick Notes"
                        minRows={3}
                        className="border border-gray-400 w-full rounded px-2"
                        style={{
                          outline: "none",
                        }}
                        maxRows={3}
                        onChange={(e) => {
                          setImpNotes(e.target.value);
                        }}
                        control={control}
                        name="importantNotes"
                        label="Quick Notes"
                      />
                    </div>

                    <div className="h-[102px] overflow-y-auto relative">
                      <h3 className="bg-customBlue text-center py-1 font-semibold uppercase tracking-widest text-white text-xs font-Poppins  sticky top-0 z-10">
                        Template Name
                      </h3>
                      {emrTemplateOption.map((temp, index) => (
                        <div
                          className={`flex items-center border-b-2 border-l-2 border-r-2 py-1 ${completeEmr !== true &&
                            selectedEMRTemplate === temp.id
                            ? "bg-yellow-400 cursor-pointer"
                            : ""
                            }`}
                          key={index}
                          onClick={() => {
                            if (completeEmr !== true) {
                              handleRowSelect(temp.id);
                            }
                          }}
                          tabIndex={0}
                        >
                          <div className="pl-2 ">
                            <h3 className="text-xs flex capitalize tracking-wider font-semibold` font-Poppins">
                              <span className="pr-2">{index + 1}.</span>
                              {temp?.label}
                            </h3>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className=" grid rounded col-span-2 lg:col-span-3 grid-cols-3 gap-3 items-start">
                    <div className="w-full h-full shadow-lg shadow-slate-300">

                      <div className="bg-[#FFD4E3] w-full px-2 flex justify-between items-center mt-2">
                        <div className="flex items-center gap-2 py-1">
                          <div className="text-md font-semibold whitespace-nowrap">
                            Past History
                          </div>

                        </div>

                        <div className="">
                          {/* <CustomCreateable
                            control={control}
                            name="pastHistory"
                            placeholder="Past History"
                            isSearchable={true}
                            dataArray={pastHistoryOptions}
                            handleInputChange={handleSearchPastHistory}
                            inputRef={{
                              ...register("pastHistory", {
                                onChange: (e) => {
                                  if (e.target.value !== null) {
                                    let duplicateObj = selectedHistory?.some(
                                      (val) =>
                                        val?.label === e?.target?.value?.label,
                                    );
                                    let historyObj = {
                                      id: e?.target?.value?.id,
                                      label: e?.target?.value?.label,
                                      description: "",
                                      duration: "",
                                      since: "",
                                      isChecked: false,
                                    };
                                    if (!duplicateObj) {
                                      setSelectedHistory([
                                        ...selectedHistory,
                                        { ...historyObj },
                                      ]);
                                    } else {
                                      warningAlert(
                                        "History already exists...!",
                                      );
                                    }
                                    setValue("pastHistory", null);
                                    setPastHistoryOptions([]);
                                  }
                                },
                              }),
                            }}
                          /> */}


                        </div>

                        <div className="flex gap-1 flex-shrink-0 justify-between py-1">
                          <Tooltip title="Create">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dcfce7",
                                color: "#166534",
                                "&:hover": { bgcolor: "#bbf7d0" },
                              }}
                              onClick={() => {
                                setTemplateValue(watch("pastHistory") || "")
                                setOpenPastHistoryModal(true)
                                setSelectedFieldId(2)
                              }}

                            >
                              <CiSquarePlus size={16} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Past History">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#ede9fe",
                                color: "#4c1d95",
                                "&:hover": { bgcolor: "#ddd6fe" },
                              }}
                              onClick={getEmrPastHistory}
                            >
                              <GoHistory size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Clear">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#fee2e2",
                                color: "#7f1d1d",
                                "&:hover": { bgcolor: "#fecaca" },
                              }}
                              onClick={() => {
                                setSelectedHistory([])
                              }}
                            >
                              <RxReset size={16} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                      <div className="w-full">
                        {/* {selectedHistory?.length > 0
                          ? selectedHistory?.map((obj, index) => {
                            return (
                              <div
                                className={`flex gap-2 justify-between items-center py-1 mt-1 px-2 border border-gray-200 h-6 ${obj.isChecked === true ? `bg-green-300` : ``
                                  } `}
                              >
                                <button
                                  type="button"
                                  onClick={() => {
                                    let dataArray = [...selectedHistory];
                                    dataArray?.splice(index, 1);
                                    setSelectedHistory(dataArray);
                                  }}
                                >
                                  <DeleteIcon />
                                </button>
                                <div
                                  className="w-full flex justify-start"
                                  onClick={() => {
                                    let dataArray = [...selectedHistory];
                                    dataArray[index].isChecked =
                                      obj?.isChecked === true ? false : true;
                                    setSelectedHistory(dataArray);
                                  }}
                                >
                                  {obj?.["label"]}
                                </div>
                                <div className="flex space-x-2 items-center">
                                  <div className="flex gap-2 items-center py-[5px]">
                                    <input
                                      name={`duration${obj.id}`}
                                      style={{ outline: "none" }}
                                      disabled={
                                        obj?.isChecked === false
                                          ? true
                                          : false
                                      }
                                      defaultValue={obj?.since}
                                      placeholder="Since"
                                      className="text-center h-6 w-20 border border-gray-400 rounded"
                                      onChange={(e) => {
                                        if (
                                          Number(e.target.value) > 0 &&
                                          selectedHistory?.length > 0
                                        ) {
                                          let dataArray = [
                                            ...selectedHistory,
                                          ];
                                          dataArray[index].since =
                                            e.target.value;
                                          dataArray[index].duration = "D";
                                          setSelectedHistory(dataArray);
                                        } else {
                                          let dataArray = [
                                            ...selectedHistory,
                                          ];
                                          dataArray[index].since = "";
                                          dataArray[index].duration = "";
                                          setSelectedHistory(dataArray);
                                        }
                                      }}
                                    />
                                    <div
                                      onClick={() => {
                                        handleAddDuration("D", index);
                                      }}
                                      className={`h-5 text-md w-5 rounded-full 
                                 ${typeof obj.duration === "string" &&
                                          obj.duration.charAt(0) === "D" &&
                                          obj.since !== ""
                                          ? `bg-[#073763] text-white`
                                          : `border border-slate-600`
                                        } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                    >
                                      D
                                    </div>
                                    <div
                                      onClick={() => {
                                        handleAddDuration("M", index);
                                      }}
                                      className={`h-5 text-md w-5 rounded-full 
                                ${typeof obj.duration === "string" &&
                                          obj.duration.charAt(0) === "M" &&
                                          obj.since !== ""
                                          ? `bg-[#073763] text-white`
                                          : `border border-slate-600`
                                        } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                    >
                                      M
                                    </div>
                                    <div
                                      onClick={() => {
                                        handleAddDuration("Y", index);
                                      }}
                                      className={`h-5 text-md w-5 rounded-full 
                                ${typeof obj.duration === "string" &&
                                          obj.duration.charAt(0) === "Y" &&
                                          obj.since !== ""
                                          ? `bg-[#073763] text-white`
                                          : `border border-slate-600`
                                        } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                    >
                                      Y
                                    </div>
                                  </div>
                                  <div>
                                    <input
                                      className="w-36 text-start px-2 h-6 rounded border border-gray-400"
                                      style={{ outline: "none" }}
                                      placeholder="Description"
                                      onChange={(e) => {
                                        let dataArray = [...selectedHistory];
                                        dataArray[index].description =
                                          e.target.value;
                                        setSelectedHistory(dataArray);
                                      }}
                                      value={obj?.description}
                                      disabled={
                                        obj.isChecked === false ? true : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })
                          : ""} */}


                        <InputAreaDropdown
                          // label={"General Examinations"}
                          minRows={2}
                          control={control}
                          name={"pastHistory"}
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getTemplateSuggetion({
                                fieldId: 2,
                                doctorId: selectedRow?.["Doctor Id"],
                                searchString: e,
                              })
                                .then((response) => {
                                  let res = response?.data?.result;
                                  console.log(res);
                                  setSuggestedData(res);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setSuggestedData([]);
                            }
                          }}
                          error={errors?.pastHistory}
                          suggestions={suggestedData}
                          onSelectedIdChange={(ids) => {
                            setSelectedPastHistory(ids);
                            console.log("idssssssssssssssss", ids);

                          }}
                          onSuggestionSelect={(item) => {
                            console.log("setValuesetValuesetValuesetValue", item);

                            setValue("pastHistory", item.value);
                            // setSelectedId(item.id);
                          }}
                        />



                      </div>
                    </div>
                    <div className="w-full h-full shadow-lg shadow-slate-300 rounded">
                      <div className="bg-[#DBEAFE] flex justify-between px-2 items-center mt-2">
                        <div className="flex items-center gap-2">
                          <div className="text-md font-semibold whitespace-nowrap">
                            Family History
                          </div>

                        </div>
                        <div className="w-[40%]">
                          {/* <CustomCreateable
                            control={control}
                            name="familyHistory"
                            placeholder="Family History"
                            isSearchable={true}
                            dataArray={pastHistoryOptions}
                            handleInputChange={handleSearchPastHistory}
                            inputRef={{
                              ...register("familyHistory", {
                                onChange: (e) => {
                                  if (e.target.value !== null) {
                                    let duplicateObj =
                                      selectedFamilyHistory?.some(
                                        (val) =>
                                          val?.label ===
                                          e?.target?.value?.label,
                                      );
                                    let historyObj = {
                                      id: e?.target?.value?.id,
                                      label: e?.target?.value?.label,
                                      description: "",
                                      duration: "",
                                      since: "",
                                      isChecked: false,
                                    };
                                    if (!duplicateObj) {
                                      setSelectedFamilyHistory([
                                        ...selectedFamilyHistory,
                                        { ...historyObj },
                                      ]);
                                    } else {
                                      warningAlert(
                                        "History already exists...!",
                                      );
                                    }
                                    setValue("familyHistory", null);
                                    setPastHistoryOptions([]);
                                  }
                                },
                              }),
                            }}
                          /> */}
                        </div>

                        <div className="flex gap-1 py-1 px-2">
                          <Tooltip title="Create">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dcfce7",
                                color: "#166534",
                                "&:hover": { bgcolor: "#bbf7d0" },
                              }}
                              onClick={() => {
                                setTemplateValue(watch("familyHistory") || "")
                                setOpenFamilyHistoryTempModal(true)
                                setSelectedFieldId(3)
                              }}
                            >
                              <CiSquarePlus size={16} />
                            </IconButton>
                          </Tooltip>

                          {/*  <Tooltip title="Edit">
                              <IconButton
                                sx={{
                                  width: 26,
                                  height: 26,
                                  p: 0.5,
                                  bgcolor: "#dbeafe",
                                  color: "#1e3a8a",
                                  "&:hover": { bgcolor: "#bfdbfe" },
                                }}
                              >
                                <CiEdit size={16} />
                              </IconButton>
                            </Tooltip> */}

                          <Tooltip title="Past History">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#ede9fe",
                                color: "#4c1d95",
                                "&:hover": { bgcolor: "#ddd6fe" },
                              }}
                              onClick={() => {
                                // setOpenFamilyHistory(true)
                                getEmrFamilyHistory()

                              }}
                            >
                              <GoHistory size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Clear">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#fee2e2",
                                color: "#7f1d1d",
                                "&:hover": { bgcolor: "#fecaca" },
                              }}
                              onClick={() => {
                                setSelectedFamilyHistory([])
                              }}
                            >
                              <RxReset size={16} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                      <div className="w-full ">
                        {/* {selectedFamilyHistory?.length > 0
                          ? selectedFamilyHistory?.map((obj, index) => {
                            return (
                              <div
                                className={`flex gap-2 justify-between items-center py-1 mt-1 px-2 border border-gray-200 h-6 ${obj.isChecked === true ? `bg-green-300` : ``
                                  } `}
                              >
                                <button
                                  type="button"
                                  onClick={() => {
                                    let dataArray = [
                                      ...selectedFamilyHistory,
                                    ];
                                    dataArray?.splice(index, 1);
                                    setSelectedFamilyHistory(dataArray);
                                  }}
                                >
                                  <DeleteIcon />
                                </button>
                                <div
                                  className="w-full flex justify-start"
                                  onClick={() => {
                                    let dataArray = [
                                      ...selectedFamilyHistory,
                                    ];
                                    dataArray[index].isChecked =
                                      obj?.isChecked === true ? false : true;
                                    setSelectedFamilyHistory(dataArray);
                                  }}
                                >
                                  {obj?.["label"]}
                                </div>
                                <div className="flex space-x-2 items-center">
                                  <div className="flex gap-2 items-center py-[5px]">
                                    <input
                                      name={`duration${obj.id}`}
                                      style={{ outline: "none" }}
                                      disabled={
                                        obj?.isChecked === false
                                          ? true
                                          : false
                                      }
                                      defaultValue={obj?.since}
                                      placeholder="Since"
                                      className="text-center h-6 w-20 border border-gray-400 rounded"
                                      onChange={(e) => {
                                        if (
                                          Number(e.target.value) > 0 &&
                                          selectedFamilyHistory?.length > 0
                                        ) {
                                          let dataArray = [
                                            ...selectedFamilyHistory,
                                          ];
                                          dataArray[index].since =
                                            e.target.value;
                                          dataArray[index].duration = "D";
                                          setSelectedFamilyHistory(dataArray);
                                        } else {
                                          let dataArray = [
                                            ...selectedFamilyHistory,
                                          ];
                                          dataArray[index].since = "";
                                          dataArray[index].duration = "";
                                          setSelectedFamilyHistory(dataArray);
                                        }
                                      }}
                                    />
                                    <div
                                      onClick={() => {
                                        handleAddFamilyHistoryDuration(
                                          "D",
                                          index,
                                        );
                                      }}
                                      className={`h-5 text-md w-5 rounded-full 
                                 ${typeof obj.duration === "string" &&
                                          obj.duration.charAt(0) === "D" &&
                                          obj.since !== ""
                                          ? `bg-[#073763] text-white`
                                          : `border border-slate-600`
                                        } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                    >
                                      D
                                    </div>
                                    <div
                                      onClick={() => {
                                        handleAddFamilyHistoryDuration(
                                          "M",
                                          index,
                                        );
                                      }}
                                      className={`h-5 text-md w-5 rounded-full 
                                ${typeof obj.duration === "string" &&
                                          obj.duration.charAt(0) === "M" &&
                                          obj.since !== ""
                                          ? `bg-[#073763] text-white`
                                          : `border border-slate-600`
                                        } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                    >
                                      M
                                    </div>
                                    <div
                                      onClick={() => {
                                        handleAddFamilyHistoryDuration(
                                          "Y",
                                          index,
                                        );
                                      }}
                                      className={`h-5 text-md w-5 rounded-full 
                                ${typeof obj.duration === "string" &&
                                          obj.duration.charAt(0) === "Y" &&
                                          obj.since !== ""
                                          ? `bg-[#073763] text-white`
                                          : `border border-slate-600`
                                        } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                    >
                                      Y
                                    </div>
                                  </div>
                                  <div>
                                    <input
                                      className="w-36 text-start px-2 h-6 rounded border border-gray-400"
                                      style={{ outline: "none" }}
                                      placeholder="Description"
                                      onChange={(e) => {
                                        let dataArray = [
                                          ...selectedFamilyHistory,
                                        ];
                                        dataArray[index].description =
                                          e.target.value;
                                        setSelectedFamilyHistory(dataArray);
                                      }}
                                      value={obj?.description}
                                      disabled={
                                        obj.isChecked === false ? true : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })
                          : ""} */}

                        <InputAreaDropdown
                          // label={"Gen"}
                          minRows={2}
                          control={control}
                          name={"familyHistory"}
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getTemplateSuggetion({
                                fieldId: 3,
                                doctorId: selectedRow?.["Doctor Id"],
                                searchString: e,
                              })
                                .then((response) => {
                                  let res = response?.data?.result;
                                  console.log(res);
                                  setSuggestedData(res);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setSuggestedData([]);
                            }
                          }}
                          error={errors?.pastHistory}
                          suggestions={suggestedData}
                          onSelectedIdChange={(id) => {
                            // setSelectedId(id);
                            setFamilyHistory(id)
                          }}
                          onSuggestionSelect={(item) => {
                            console.log("setValuesetValuesetValuesetValue", item);

                            setValue("familyHistory", item.value);
                            // setSelectedId(item.id);
                          }}
                        />
                      </div>
                    </div>
                    <div className=" grid grid-cols-12 gap-2">

                      <div className="col-span-12">


                        <div className="flex gap-1 py-3">
                          <Tooltip title="Create">
                            <IconButton
                              sx={{
                                ...iconButtonStyle,
                                bgcolor: "#dcfce7",
                                color: "#166534",
                                "&:hover": { bgcolor: "#bbf7d0" },
                              }}
                              onClick={() => {
                                const hopi = watch("hopi")?.trim()
                                // handleTemplateOnSubmit(4)
                                setTemplateValue(watch("hopi") || "")
                                setOpenModal(true);
                                setSelectedFieldId(4);

                              }}
                            >
                              <CiSquarePlus size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Edit">
                            <IconButton
                              sx={{
                                ...iconButtonStyle,
                                bgcolor: "#dbeafe",
                                color: "#1e3a8a",
                                "&:hover": { bgcolor: "#bfdbfe" },
                              }}
                            >
                              <CiEdit size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Past History">
                            <IconButton
                              sx={{
                                ...iconButtonStyle,
                                bgcolor: "#ede9fe",
                                color: "#4c1d95",
                                "&:hover": { bgcolor: "#ddd6fe" },
                              }}
                              onClick={getEmrHOPIPastHistory}
                            >
                              <GoHistory size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Clear">
                            <IconButton
                              sx={{
                                ...iconButtonStyle,
                                bgcolor: "#fee2e2",
                                color: "#7f1d1d",
                                "&:hover": { bgcolor: "#fecaca" },
                              }}
                              onClick={() => {
                                setValue("hopi", "")
                              }}
                            >
                              <RxReset size={16} />
                            </IconButton>
                          </Tooltip>
                          {/* <div className="pl-3"><button onClick={() => {
                            handleTemplateOnSubmit(4)
                          }} className="p-1 text-xs px-2 bg-customBlue text-white rounded">Add Template</button></div> */}
                        </div>
                        <InputAreaDropdown
                          label={"HOPI"}
                          minRows={1}
                          control={control}
                          name={"hopi"}
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getTemplateSuggetion({
                                fieldId: 4,
                                doctorId: selectedRow?.["Doctor Id"],
                                searchString: e,
                              })
                                .then((response) => {
                                  let res = response?.data?.result;
                                  console.log("setSuggestedDatasetSuggestedData", res);
                                  setSuggestedData(res);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setSuggestedData([]);
                            }
                          }}
                          error={errors?.hopi}
                          suggestions={suggestedData}
                          onSelectedIdChange={(id) => {
                            setSelectedHopis(id);
                            console.log("Selected Strings:", id);
                          }}
                          onSuggestionSelect={(item) => {
                            console.log("setValuesetValuesetValuesetValue", item);

                            setValue("hopi", item.value);
                            // setSelectedId(item.id);
                          }}
                        />
                      </div>
                      <div className="col-span-12">


                        <div className="shadow-lg shadow-slate-300 rounded h-28 pt-2">
                          <div className=" bg-[#DCFCE7] text-md font-semibold flex justify-between px-2">
                            <div
                              className="whitespace-nowrap"
                              onClick={() => {
                                setOpenComplaints(true);
                              }}
                            >
                              Complaints
                            </div>

                            <fieldset className="w-[75%] ml-2 flex ">
                              {/* <div className="w-full" ref={complaintFocusRef}>
                                <CustomCreateable
                                  width={"170px"}
                                  control={control}
                                  name={"createComplaint"}
                                  placeholder={"Complaint"}
                                  dataArray={complaintsOptions}
                                  isSearchable={true}
                                  showSearch={true}
                                  handleInputChange={handleSearchComplaints}
                                  onKeyDown={(e) => {
                                    if (e.key === "Tab") {
                                      allergyFocusRef?.current()?.focus();
                                    }
                                  }}
                                />
                              </div> */}

                              {editComplaintIndex !== null && (
                                <Tooltip title="Update">
                                  <button
                                    onClick={() => {
                                      handleUpdateComplaint();
                                    }}
                                    className=" rounded-full bg-customBlue text-white"
                                  >
                                    <NavigateNextIcon />
                                  </button>
                                </Tooltip>
                              )}
                            </fieldset>

                            {/* ONLY ADDED ICONS BELOW - NOTHING ELSE CHANGED */}
                            <div className="flex gap-1">

                              <Tooltip title="Create">
                                <IconButton
                                  sx={{
                                    width: 26,
                                    height: 26,
                                    p: 0.5,
                                    bgcolor: "#dcfce7",
                                    color: "#166534",
                                    "&:hover": { bgcolor: "#bbf7d0" },
                                  }}
                                  onClick={() => {
                                    setTemplateValue(watch("complaints") || "")
                                    setOpenComplaintTempModal(true)
                                    // setOpenComplaints(true);
                                    setSelectedFieldId(5)
                                  }}
                                >
                                  <CiSquarePlus size={16} />
                                </IconButton>
                              </Tooltip>

                              {/* <Tooltip title="Edit">
                                <IconButton
                                  sx={{
                                    width: 26,
                                    height: 26,
                                    p: 0.5,
                                    bgcolor: "#dbeafe",
                                    color: "#1e3a8a",
                                    "&:hover": { bgcolor: "#bfdbfe" },
                                  }}
                                >
                                  <CiEdit size={16} />
                                </IconButton>
                              </Tooltip> */}

                              <Tooltip title="PastHistory">
                                <IconButton
                                  sx={{
                                    width: 26,
                                    height: 26,
                                    p: 0.5,
                                    bgcolor: "#ede9fe",
                                    color: "#4c1d95",
                                    "&:hover": { bgcolor: "#ddd6fe" },
                                  }}
                                  onClick={getEmrComplaintsHistroy}
                                >
                                  <GoHistory size={16} />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Clear">
                                <IconButton
                                  sx={{
                                    width: 26,
                                    height: 26,
                                    p: 0.5,
                                    bgcolor: "#fee2e2",
                                    color: "#7f1d1d",
                                    "&:hover": { bgcolor: "#fecaca" },
                                  }}
                                  onClick={() => {
                                    setSelectedComplaints([])
                                  }}
                                >
                                  <RxReset size={16} />
                                </IconButton>
                              </Tooltip>

                            </div>
                          </div>
                          <div className=" h-[82%] ">

                            {/* {selectedComplaints?.length > 0
                              ? selectedComplaints?.map((obj, index) => {
                                return (
                                  <div
                                    className={`flex sapce-x-1 justify-between items-center my-1  px-1 border border-gray-200`}
                                  >
                                    <div className="flex items-center">
                                      <div>
                                        <Tooltip title="Edit Complaint">
                                          <button
                                            className="h-4 "
                                            type="button"
                                            onClick={() => {
                                              handleEditComplaint(obj, index);
                                            }}
                                          >
                                            <EditIcon />
                                          </button>
                                        </Tooltip>
                                      </div>
                                      <div>
                                        <button
                                          className="h-5 "
                                          type="button"
                                          onClick={() => {
                                            handleDeleteComplaints(obj);
                                          }}
                                        >
                                          <DeleteOutlineIcon
                                            fontSize="small"
                                            sx={{ color: "red" }}
                                          />
                                        </button>
                                      </div>
                                      <div className="w-full flex items-center whitespace-pre-wrap text-start justify-start text-sm">
                                        {obj?.["label"]}
                                      </div>
                                    </div>
                                    <div className="flex space-x-1 items-center py-1">
                                      <input
                                        name={`duration${obj.id}`}
                                        style={{ outline: "none" }}
                                        disabled={
                                          obj?.isChecked === false ? true : false
                                        }
                                        defaultValue={obj?.since}
                                        placeholder="Since"
                                        className="text-center h-6 w-[60px] border border-gray-400 rounded"
                                        onChange={(e) => {
                                          if (Number(e.target.value) > 0) {
                                            let dataArray = [
                                              ...selectedComplaints,
                                              ...complaints,
                                            ];
                                            dataArray[index].since = e.target.value;
                                            dataArray[index].duration = "D";
                                            setComplaints(dataArray);
                                          } else {
                                            let dataArray = [
                                              ...selectedComplaints,
                                              ...complaints,
                                            ];
                                            dataArray[index].since = "";
                                            dataArray[index].duration = "";
                                            setComplaints(dataArray);
                                          }
                                        }}
                                      />
                                      <div
                                        onClick={() => {
                                          handleAddComplaintsDuration("D", index);
                                        }}
                                        className={`h-5 text-md w-5 rounded-full 
                                 ${obj.duration === "D" && obj.since !== ""
                                            ? `bg-[#073763] text-white`
                                            : `border border-slate-600`
                                          } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                      >
                                        D
                                      </div>
                                      <div
                                        onClick={() => {
                                          handleAddComplaintsDuration("M", index);
                                        }}
                                        className={`h-5 text-md w-5 rounded-full 
                                ${obj.duration === "M" && obj.since !== ""
                                            ? `bg-[#073763] text-white`
                                            : `border border-slate-600`
                                          } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                      >
                                        M
                                      </div>
                                      <div
                                        onClick={() => {
                                          handleAddComplaintsDuration("Y", index);
                                        }}
                                        className={`h-5 text-md w-5 rounded-full 
                                ${obj.duration === "Y" && obj.since !== ""
                                            ? `bg-[#073763] text-white`
                                            : `border border-slate-600`
                                          } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                      >
                                        Y
                                      </div>
                                      <input
                                        type="text"
                                        className="text-center h-6 w-[100px] border border-gray-400 rounded"
                                        name={`description${obj.id}`}
                                        placeholder="Description"
                                        value={obj?.description}
                                        onChange={(e) => {
                                          if (e.target.value) {
                                            let dataArray = [
                                              ...selectedComplaints,
                                              ...complaints,
                                            ];
                                            dataArray[index].description =
                                              e.target.value;
                                            setComplaints(dataArray);
                                          } else {
                                            let dataArray = [
                                              ...selectedComplaints,
                                              ...complaints,
                                            ];
                                            dataArray[index].description = "";
                                            setComplaints(dataArray);
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })
                              : ""} */}
                            <InputAreaDropdown
                              // label={"Gen"}
                              minRows={2}
                              control={control}
                              name={"complaints"}
                              handleInputChange={(e) => {
                                const tempCheckChar =
                                  e !== null
                                    ? UseCheckConsecutiveCharacters(e)
                                    : true;
                                if (e !== "" && tempCheckChar) {
                                  getTemplateSuggetion({
                                    fieldId: 5,
                                    doctorId: selectedRow?.["Doctor Id"],
                                    searchString: e,
                                  })
                                    .then((response) => {
                                      let res = response?.data?.result;
                                      console.log(res);
                                      setSuggestedData(res);
                                    })
                                    .catch((error) => {
                                      console.log(error);
                                    });
                                } else {
                                  setSuggestedData([]);
                                }
                              }}
                              error={errors?.complaints}
                              suggestions={suggestedData}
                              onSelectedIdChange={(id) => {
                                // setSelectedId(id);
                                setSelectedAdvice(id)
                              }}
                              onSuggestionSelect={(item) => {
                                console.log("setValuesetValuesetValuesetValue", item);

                                setValue("complaints", item.value);
                                // setSelectedId(item.id);
                              }}
                            />
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>




                <div className="grid  lg:grid-cols-2 xl:grid-cols-4 gap-2 items-center mt-2">

                  <div className="shadow-lg shadow-slate-300 rounded h-64">
                    <div className=" bg-[#EDE9FE] text-md font-semibold items-center flex justify-between px-2">

                      {/* LEFT SIDE: HEADING + ICONS STACK */}
                      <div className="flex flex-col">

                        <div
                          className="w-[] px-1"
                          onClick={() => {
                            setOpenAllergy(true);
                          }}
                        >
                          Allergic
                        </div>


                      </div>

                      {/* RIGHT SIDE INPUT (UNCHANGED) */}
                      {/* <div className=" w-[65%]" ref={allergyFocusRef}>
                        <CustomCreateable
                          control={control}
                          name="searchAllergy"
                          dataArray={allergyOption}
                          placeholder={"Allergies"}
                          handleInputChange={handleSearchAllergies}
                          isSearchable={true}
                          isClearable={true}
                        />
                      </div> */}
                      <div className="flex gap-1 mt-1 px-2">

                        <Tooltip title="Create">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dcfce7",
                              color: "#166534",
                              "&:hover": { bgcolor: "#bbf7d0" },
                            }}
                            onClick={() => {
                              setTemplateValue(watch("allergy") || "")
                              setOpenAllergyTemplateModal(true)
                              setSelectedFieldId(6)
                              // setOpenAllergy(true);
                            }}
                          >
                            <CiSquarePlus size={16} />
                          </IconButton>
                        </Tooltip>

                        {/* <Tooltip title="Edit">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dbeafe",
                              color: "#1e3a8a",
                              "&:hover": { bgcolor: "#bfdbfe" },
                            }}
                          >
                            <CiEdit size={16} />
                          </IconButton>
                        </Tooltip> */}

                        <Tooltip title="Past History">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#ede9fe",
                              color: "#4c1d95",
                              "&:hover": { bgcolor: "#ddd6fe" },
                            }}
                            onClick={getEmrAllergiesPastHistory}
                          >
                            <GoHistory size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Clear">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#fee2e2",
                              color: "#7f1d1d",
                              "&:hover": { bgcolor: "#fecaca" },
                            }}
                            onClick={() => {
                              setSelectedAllergy([])
                            }}
                          >
                            <RxReset size={16} />
                          </IconButton>
                        </Tooltip>

                      </div>
                    </div>
                    <div className="h-[78%]">
                      {/* {selectedAllergy?.length > 0
                        ? selectedAllergy.map((allergy) => (
                          <div className="flex gap-2 items-center border border-gray-200 h-6">
                            <div>
                              <button
                                className="h-5 "
                                type="button"
                                onClick={() => {
                                  handleDeleteAllergy(allergy);
                                }}
                              >
                                <DeleteOutlineIcon
                                  fontSize="small"
                                  sx={{ color: "red" }}
                                />
                              </button>
                            </div>
                        

                            <div className="w-[90%] h-5 flex justify-start px-2  whitespace-nowrap truncate">
                              {allergy?.label}
                            </div>
                          </div>
                        ))
                        : ""} */}
                      <InputAreaDropdown
                        // label={"Gen"}
                        minRows={2}
                        control={control}
                        name={"allergy"}
                        handleInputChange={(e) => {
                          const tempCheckChar =
                            e !== null
                              ? UseCheckConsecutiveCharacters(e)
                              : true;
                          if (e !== "" && tempCheckChar) {
                            getTemplateSuggetion({
                              fieldId: 6,
                              doctorId: selectedRow?.["Doctor Id"],
                              searchString: e,
                            })
                              .then((response) => {
                                let res = response?.data?.result;
                                console.log(res);
                                setSuggestedData(res);
                              })
                              .catch((error) => {
                                console.log(error);
                              });
                          } else {
                            setSuggestedData([]);
                          }
                        }}
                        error={errors?.allergy}
                        suggestions={suggestedData}
                        onSelectedIdChange={(id) => {
                          // setSelectedId(id);
                          setAllergySuggestions(id)
                        }}
                        onSuggestionSelect={(item) => {
                          console.log("setValuesetValuesetValuesetValue", item);

                          setValue("allergy", item.value);
                          // setSelectedId(item.id);
                        }}
                      />
                    </div>
                  </div>
                  <div className="shadow-lg shadow-slate-300 rounded h-64">
                    <div className="cursor-pointer bg-[#FFE6C9] text-md font-semibold flex items-center px-2">

                      <div
                        className="text-base px-1 whitespace-nowrap lg:text-md font-semibold flex gap-2"
                        onClick={() => {
                          setOpenInvestigation(true);
                        }}
                      >
                        Investigations
                      </div>

                      <div className="flex  space-x-1 items-center w-full">
                        <Tooltip title="Investigations">
                          <button
                            type="button"
                            onClick={() => {
                              setOpenLabModal(true);
                            }}
                          >
                            <LIMSIcon />
                          </button>
                        </Tooltip>

                        <div className="w-[90%] z-50" ref={investigationFocusRef}>
                          <CustomCreateable
                            width={"200px"}
                            control={control}
                            name={"searchInvestigations"}
                            dataArray={invOptions}
                            placeholder={"Investigations"}
                            isClearable={true}
                            searchIcon={true}
                            isSearchable={true}
                            handleInputChange={handleSearchInvestigations}
                          />
                        </div>
                      </div>

                      {/* ✅ ICONS ADDED AT END */}
                      <div className="flex gap-0.5  flex-shrink-0 ">

                        <Tooltip title="Create">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dcfce7",
                              color: "#166534",
                              "&:hover": { bgcolor: "#bbf7d0" },
                            }}
                            onClick={() => {
                              setOpenInvestigation(true);
                            }}
                          >
                            <CiSquarePlus size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Edit">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dbeafe",
                              color: "#1e3a8a",
                              "&:hover": { bgcolor: "#bfdbfe" },
                            }}
                          >
                            <CiEdit size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Past History">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#ede9fe",
                              color: "#4c1d95",
                              "&:hover": { bgcolor: "#ddd6fe" },
                            }}
                            onClick={getEmrInvestigationPastHistory}
                          >
                            <GoHistory size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Clear">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#fee2e2",
                              color: "#7f1d1d",
                              "&:hover": { bgcolor: "#fecaca" },
                            }}
                            onClick={() => {
                              setSelectedInvestigations([])

                            }}
                          >
                            <RxReset size={16} />
                          </IconButton>
                        </Tooltip>

                      </div>
                    </div>
                    <div className="h-[82%] overflow-y-scroll">
                      {selectedInvestigations?.length > 0
                        ? selectedInvestigations.map((inv) => {
                          setValue(`isUrgent${inv?.id}`, inv?.isUrgent);
                          return (
                            <div className="flex gap-2 items-center border border-gray-200 py h-6">
                              {/* {inv?.isUrgent === false ? (  by Abhijeet sir */}
                              <div>
                                <button
                                  className="h-5 "
                                  type="button"
                                  onClick={() => {
                                    handleDeleteInv(inv);
                                  }}
                                >
                                  <DeleteOutlineIcon
                                    fontSize="small"
                                    sx={{ color: "red" }}
                                  />
                                </button>
                              </div>
                              {/* ) : (
                            ""
                          )} */}

                              <div className="w-[90%] h-5 flex justify-start px-2  whitespace-nowrap truncate">
                                {inv?.label}
                              </div>
                            </div>
                          );
                        })
                        : ""}
                    </div>
                  </div>

                  <div className="shadow-lg shadow-slate-300 rounded h-64">
                    <div className=" bg-[#ECFCCB] items-center text-md font-semibold flex gap-2 px-2 cursor-pointer">

                      <div
                        className="w-[]"
                        onClick={() => {
                          setOpenDiagnosis(true);
                        }}
                      >
                        Diagnosis
                      </div>

                      <div
                        className="flex justify-end w-full"
                        ref={diagnosisFocusRef}
                      >
                        <CustomCreateable
                          control={control}
                          name={"searchDiagnosis"}
                          dataArray={diagnoOptions}
                          placeholder={"Diagnosis"}
                          handleInputChange={handelSearchDiagnosis}
                          width={"170px"}
                          isSearchable={true}
                        />
                      </div>

                      {/* ✅ ICONS ADDED AT END OF ROW */}
                      <div className="flex gap-1 flex-shrink-0 py-1">

                        <Tooltip title="Create">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dcfce7",
                              color: "#166534",
                              "&:hover": { bgcolor: "#bbf7d0" },
                            }}
                            onClick={() => {
                              setOpenDiagnosis(true);
                            }}
                          >
                            <CiSquarePlus size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Edit">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dbeafe",
                              color: "#1e3a8a",
                              "&:hover": { bgcolor: "#bfdbfe" },
                            }}
                          >
                            <CiEdit size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title=" Past History">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#ede9fe",
                              color: "#4c1d95",
                              "&:hover": { bgcolor: "#ddd6fe" },
                            }}
                            onClick={getEmrDiagnosisPastHistroy}
                          >
                            <GoHistory size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Clear">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#fee2e2",
                              color: "#7f1d1d",
                              "&:hover": { bgcolor: "#fecaca" },
                            }}
                            onClick={() => {
                              setSelectedDiagnosis([])
                            }}
                          >
                            <RxReset size={16} />
                          </IconButton>
                        </Tooltip>

                      </div>
                    </div>
                    <div className=" h-[82%] overflow-y-scroll">
                      {selectedDiagnosis?.length > 0
                        ? selectedDiagnosis.map((obj, index) => {
                          return (
                            <div
                              className={`flex gap-2 items-center my-1  px-2 border border-gray-200 h-[26px]`}
                            >
                              <div>
                                <button
                                  className="h-5 "
                                  type="button"
                                  onClick={() => {
                                    handleDeleteDiagnosis(obj);
                                  }}
                                >
                                  <DeleteOutlineIcon
                                    fontSize="small"
                                    sx={{ color: "red" }}
                                  />
                                </button>
                              </div>

                              <div className="w-[70%] truncate flex justify-start px-2 ">
                                {obj?.label}
                              </div>

                              {/* <div className="flex gap-2 items-center py-[5px]">
                                  <input
                                    name={`daignosis${obj.id}`}
                                    style={{ outline: "none" }}
                                    disabled={
                                      obj?.isChecked === false ? true : false
                                    }
                                    defaultValue={obj?.since}
                                    placeholder="Since"
                                    className="text-center h-6 w-[60px] border border-gray-400 rounded"
                                    onChange={(e) => {
                                      if (Number(e.target.value) > 0) {
                                        let dataArray = [
                                          ...selectedDiagnosis,
                                          ...diagnosis,
                                        ];
                                        dataArray[index].since = e.target.value;
                                        dataArray[index].duration = "D";
                                        setComplaints(dataArray);
                                      } else {
                                        let dataArray = [
                                          ...selectedDiagnosis,
                                          ...diagnosis,
                                        ];
                                        dataArray[index].since = "";
                                        dataArray[index].duration = "";
                                        setComplaints(dataArray);
                                      }
                                    }}
                                  />
                                  <div
                                    onClick={() => {
                                      handleAddDiagnosisDuration("D", index);
                                    }}
                                    className={`h-5 text-md w-5 rounded-full 
                                 ${
                                   obj.duration === "D" && obj.since !== ""
                                     ? `bg-[#073763] text-white`
                                     : `border border-slate-600`
                                 } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                  >
                                    D
                                  </div>
                                  <div
                                    onClick={() => {
                                      handleAddDiagnosisDuration("M", index);
                                    }}
                                    className={`h-5 text-md w-5 rounded-full 
                                ${
                                  obj.duration === "M" && obj.since !== ""
                                    ? `bg-[#073763] text-white`
                                    : `border border-slate-600`
                                } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                  >
                                    M
                                  </div>
                                  <div
                                    onClick={() => {
                                      handleAddDiagnosisDuration("Y", index);
                                    }}
                                    className={`h-5 text-md w-5 rounded-full 
                                ${
                                  obj.duration === "Y" && obj.since !== ""
                                    ? `bg-[#073763] text-white`
                                    : `border border-slate-600`
                                } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                                  >
                                    Y
                                  </div>
                                </div> */}
                            </div>
                          );
                        })
                        : ""}
                    </div>
                  </div>



                  <div>
                    <div className=" bg-[#ECFCCB] text-md font-semibold flex gap-2 px-2 cursor-pointer py-1">

                      <div
                        className="w-[]"
                      // onClick={() => {
                      //   setOpenDiagnosis(true);
                      // }}
                      >
                        Systematic Examinations
                      </div>

                      {/* ✅ ICONS ADDED AT END OF ROW */}
                      <div className="flex gap-1 ml-auto">

                        <Tooltip title="New Template">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dcfce7",
                              color: "#166534",
                              "&:hover": { bgcolor: "#bbf7d0" },
                            }}
                            onClick={() => {
                              setNewTemplateForSystematicExam(true)
                              setSelectedFieldId(9);

                            }}
                          >
                            <CiSquarePlus size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Template">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dbeafe",
                              color: "#1e3a8a",
                              "&:hover": { bgcolor: "#bfdbfe" },
                            }}
                            onClick={() => {
                              setOpenSystemeticExam(true)

                            }}
                          >
                            <CiEdit size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Past History">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#ede9fe",
                              color: "#4c1d95",
                              "&:hover": { bgcolor: "#ddd6fe" },
                            }}
                            onClick={() => {
                              const systematicExaminations = {
                                RS: "B/L air entry equal",
                                CVS: "S1 S2 heard",
                                CNS: "Conscious",
                                PA: "Soft",
                                Other: "No abnormality detected",
                              };

                              setValue("rs", systematicExaminations?.RS);
                              setValue("cvs", systematicExaminations?.CVS);
                              setValue("cns", systematicExaminations?.CNS);
                              setValue("pa", systematicExaminations?.PA);
                              setValue("seOther", systematicExaminations?.Other);
                            }}

                          >
                            <GoHistory size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Clear">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#fee2e2",
                              color: "#7f1d1d",
                              "&:hover": { bgcolor: "#fecaca" },
                            }}
                            onClick={() => {
                              setValue("rs", "");
                              setValue("cvs", "");
                              setValue("cns", "");
                              setValue("pa", "");
                              setValue("seOther", "");
                            }}
                          >
                            <RxReset size={16} />
                          </IconButton>
                        </Tooltip>

                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      {/* RS */}
                      <div className=" ">
                        <InputArea
                          control={control}
                          name="rs"
                          label="RS "
                          placeholder="RS"
                        />
                      </div>
                      {/* CVS */}
                      <div className=" ">
                        <InputArea
                          control={control}
                          name="cvs"
                          label="CVS "
                          placeholder="CVS"
                        />
                      </div>
                      {/* CNS */}
                      <div className=" ">
                        <InputArea
                          control={control}
                          name="cns"
                          label="CNS "
                          placeholder="CNS"
                        />
                      </div>
                      {/* PA */}
                      <div className=" ">
                        <InputArea
                          control={control}
                          name="pa"
                          label="PA "
                          placeholder="PA"
                        />
                      </div>
                      <div className="col-span-2">
                        <InputArea
                          control={control}
                          name="seOther"
                          label="Other "
                          placeholder="Other"
                        />
                      </div>
                    </div>
                    <div className="">
                      <div className=" flex justify-between  bg-[#ECFCCB] text-md font-semibold flex gap-2 px-2 cursor-pointer">
                        <div


                        >
                          General Examinations
                        </div>
                        <div className="flex gap-1 flex-shrink-0 justify-between py-1">

                          <Tooltip title="Create">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dcfce7",
                                color: "#166534",
                                "&:hover": { bgcolor: "#bbf7d0" },
                              }}
                              onClick={() => {
                                setTemplateValue(watch("generalExaminations") || "")
                                setOpenGeneralExamModal(true)
                                setSelectedFieldId(10)
                              }}
                            >
                              <CiSquarePlus size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Edit">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dbeafe",
                                color: "#1e3a8a",
                                "&:hover": { bgcolor: "#bfdbfe" },
                              }}
                            >
                              <CiEdit size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title=" Past History">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#ede9fe",
                                color: "#4c1d95",
                                "&:hover": { bgcolor: "#ddd6fe" },
                              }}
                            // onClick={getEmrDiagnosisPastHistroy}
                            >
                              <GoHistory size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Clear">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#fee2e2",
                                color: "#7f1d1d",
                                "&:hover": { bgcolor: "#fecaca" },
                              }}
                              onClick={() => {
                                setSelectedDiagnosis([])
                              }}
                            >
                              <RxReset size={16} />
                            </IconButton>
                          </Tooltip>

                        </div>
                      </div>

                      <div className=" space-y-1">

                        <div>
                          {/* <InputArea
                                             control={control}
                                             name={"hopi"}
                                             label={"History Of Present Illness"}
                                             minRows={5}
                                           /> */}
                          <InputAreaDropdown
                            label={"General Examinations"}
                            minRows={2}
                            control={control}
                            name={"generalExaminations"}
                            handleInputChange={(e) => {
                              const tempCheckChar =
                                e !== null
                                  ? UseCheckConsecutiveCharacters(e)
                                  : true;
                              if (e !== "" && tempCheckChar) {
                                getTemplateSuggetion({
                                  fieldId: 10,
                                  doctorId: selectedRow?.["Doctor Id"],
                                  searchString: e,
                                })
                                  .then((response) => {
                                    let res = response?.data?.result;
                                    console.log(res);
                                    setSuggestedData(res);
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                  });
                              } else {
                                setSuggestedData([]);
                              }
                            }}
                            error={errors?.hopi}
                            suggestions={suggestedData}
                            onSelectedIdChange={(ids) => {
                              setSelectedGeneralExam(ids);
                              console.log("idssssssssssssssss", ids);

                            }}
                            onSuggestionSelect={(item) => {
                              console.log("setValuesetValuesetValuesetValue", item);

                              setValue("generalExaminations", item.value);
                              // setSelectedId(item.id);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>












                </div>
                <div className="my-4 grid gap-2 rounded  shadow-lg shadow-slate-300">




                  <div className="">
                    <MedicinesTable
                      highlightRow={false}
                      tableClass="h-[270px]"
                      renderInput={renderInput}
                      renderActions={renderActions}
                      handleAllDurations={handleAllDurations}
                      setApplyToAllMedicines={setApplyToAllMedicines}
                      editableColumns={[
                        "Medicine",
                        "Dosage",
                        "Generic",
                        "Frequency",
                        "Duration",
                        "Instructions",
                        "Route",
                        "Quantity",
                        "Form",
                      ]}
                      removeHeaders={[
                        "since",
                        "Since",
                        "",
                        "Days",
                        "Id",
                        "id",
                        "isDeleted",
                        "isNew",
                      ]}
                      dataResult={selectedMedicines || []}
                      setDataResult={setSelectedMedicines || []}
                      setMedicineTemplateValue={setMedicineTemplateValue}
                      medicineTemplateData={medicineTemplateData}
                      handleGetTemplateMedicine={handleGetTemplateMedicine}
                      emrTemplateOption={emrTemplateOption}
                      getEmrMedicationsPastHistory={getEmrMedicationsPastHistory}
                      copyPatientPrescription={copyPatientPrescription}
                      setOpenOldMedicationsModal={setOpenOldMedicationsModal}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 xl:grid-cols-4 gap-2 items-center">
                  <div className="rounded shadow-lg shadow-slate-300">
                    <div className="col-span-2 h-36 ">
                      <div className="  h-9 flex justify-between px-2 pt-1 bg-[#F1F1F1]">

                        <div className="text-md font-semibold px-1 flex gap-2">
                          Advices
                        </div>

                        {/* <div className="w-[65%]" ref={advicesFocusRef}>
                          <CustomCreateable
                            width={"170px"}
                            control={control}
                            name={"searchAdvices"}
                            placeholder={"Advices"}
                            dataArray={advicesOptions}
                            handleInputChange={handleSearchAdvices}
                            isSearchable={true}
                            showSearch={true}
                          />
                        </div> */}

                        {/* ✅ ICONS ADDED AT END */}
                        <div className="flex gap-1 flex-shrink-0">

                          <Tooltip title="Create">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dcfce7",
                                color: "#166534",
                                "&:hover": { bgcolor: "#bbf7d0" },
                              }}
                              onClick={() => {
                                setTemplateValue(watch("advices") || "")
                                setOpenAdviceModal(true)
                                setSelectedFieldId(12)
                              }}
                            >
                              <CiSquarePlus size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Edit">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dbeafe",
                                color: "#1e3a8a",
                                "&:hover": { bgcolor: "#bfdbfe" },
                              }}
                            >
                              <CiEdit size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Past History">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#ede9fe",
                                color: "#4c1d95",
                                "&:hover": { bgcolor: "#ddd6fe" },
                              }}
                              onClick={getEmrAdvicesPastHistory}
                            >
                              <GoHistory size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Clear">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#fee2e2",
                                color: "#7f1d1d",
                                "&:hover": { bgcolor: "#fecaca" },
                              }}
                              onClick={() => {
                                setValue("advices", "")
                              }}
                            >
                              <RxReset size={16} />
                            </IconButton>
                          </Tooltip>

                        </div>
                      </div>
                      <div className="font-semibold rounded h-[75%] overflow-y-scroll ">
                        {/* {adviceTemplates.map((template) => {
                    return (
                      <div key={template.Template}>
                        {template.Advices.map((advice, index) => {
                          return (
                            <div
                              key={index}
                              className="whitespace-nowrap flex space-x-3 px-2 border border-gray-200 py-1"
                            >
                              <div>
                                <button
                                  className="h-5"
                                  onClick={() =>
                                    handleDeleteAdvice(template, index)
                                  }
                                  type="button"
                                >
                                  <DeleteOutlineIcon
                                    sx={{ color: "red" }}
                                    fontSize="small"
                                  />
                                </button>
                              </div>
                              <div>{advice}</div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })} */}

                        {/* {selectedAdvices?.length > 0 
                          ? selectedAdvices.map((advice) => (
                            <div className="flex gap-2 items-center border border-gray-200 h-6">
                              <div>
                                <button
                                  className="h-5 "
                                  type="button"
                                  onClick={() => {
                                    handleDeleteAdvice(advice);
                                  }}
                                >
                                  <DeleteOutlineIcon
                                    fontSize="small"
                                    sx={{ color: "red" }}
                                  />
                                </button>
                              </div>
                              {/* ) : (
                            ""
                          )} */}

                        {/* <div className="w-[90%] h-5 flex justify-start px-2 font-normal whitespace-nowrap truncate">
                                {advice?.label}
                              </div>
                            </div>
                          ))
                          : ""} */}


                        <InputAreaDropdown
                          // label={"Gen"}
                          minRows={2}
                          control={control}
                          name={"advices"}
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getTemplateSuggetion({
                                fieldId: 12,
                                doctorId: selectedRow?.["Doctor Id"],
                                searchString: e,
                              })
                                .then((response) => {
                                  let res = response?.data?.result;
                                  console.log(res);
                                  setSuggestedData(res);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setSuggestedData([]);
                            }
                          }}
                          error={errors?.hopi}
                          suggestions={suggestedData}
                          onSelectedIdChange={(id) => {
                            // setSelectedId(id);
                            setSelectedAdvice(id)
                          }}
                          onSuggestionSelect={(item) => {
                            console.log("setValuesetValuesetValuesetValue", item);

                            setValue("advices", item.value);
                            // setSelectedId(item.id);
                          }}
                        />


                      </div>
                    </div>
                  </div>
                  <div className="shadow-lg shadow-slate-300 rounded">
                    <div className="col-span-2 h-36 ">
                      <div className="flex justify-between px-2 pt-1 bg-[#F1F1F1]">
                        <div className="text-sm lg:text-md font-semibold flex gap-2">
                          <div
                            onClick={() => {
                              setOpenOtherRefferal(true);
                            }}
                          >
                            {/* Local Advices */}
                            Other Referral
                          </div>
                        </div>

                        <div className=" w-[65%]" ref={otherReferralFocusRef}>
                          <SearchDropdown
                            control={control}
                            name="referralDoctor"
                            dataArray={referralDocOptions}
                            placeholder={"Referral Doctor"}
                            isClearable={true}
                            searchIcon={true}
                            isSearchable={true}
                            handleInputChange={handleOtherReferral}
                          />
                        </div>
                      </div>
                      <div className="h-[75%] overflow-y-scroll">
                        {selectedOtherReferral?.length > 0
                          ? selectedOtherReferral.map((doc) => (
                            <div className="flex gap-2 items-center border border-gray-200 h-6">
                              <div>
                                <button
                                  className="h-5 "
                                  type="button"
                                  onClick={() => {
                                    handleDeleteOtherReferral(doc);
                                  }}
                                >
                                  <DeleteOutlineIcon
                                    fontSize="small"
                                    sx={{ color: "red" }}
                                  />
                                </button>
                              </div>
                              {/* ) : (
                            ""
                          )} */}

                              <div className="w-[90%] h-5 flex justify-start px-2  whitespace-nowrap truncate">
                                {doc?.label}
                              </div>
                            </div>
                          ))
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="shadow-lg shadow-slate-300 rounded">
                    <div className=" rounded h-36">
                      <div className=" items-center flex justify-between bg-[#FFE6C9]">

                        <div
                          onClick={() => {
                            setOpenServices(true);
                          }}
                          className="text-xs  px-1 whitespace-nowrap lg:text-md font-semibold flex gap-2"  >
                          Other Services
                        </div>

                        <div className="w-[65%]" ref={otherServicesFocusRef}>
                          <CustomCreateable
                            width={"170px"}
                            control={control}
                            name={"searchOtherServices"}
                            placeholder={"Other Services"}
                            dataArray={servicesOptions}
                            handleInputChange={handleSearchServices}
                            isSearchable={true}
                            showSearch={true}
                          />
                        </div>


                        {/* <div className="flex gap-1 flex-shrink-0">

                          <Tooltip title="Create">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dcfce7",
                                color: "#166534",
                                "&:hover": { bgcolor: "#bbf7d0" },
                              }}
                            >
                              <CiSquarePlus size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Edit">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#dbeafe",
                                color: "#1e3a8a",
                                "&:hover": { bgcolor: "#bfdbfe" },
                              }}
                            >
                              <CiEdit size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="History">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#ede9fe",
                                color: "#4c1d95",
                                "&:hover": { bgcolor: "#ddd6fe" },
                              }}
                            >
                              <GoHistory size={16} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Clear">
                            <IconButton
                              sx={{
                                width: 26,
                                height: 26,
                                p: 0.5,
                                bgcolor: "#fee2e2",
                                color: "#7f1d1d",
                                "&:hover": { bgcolor: "#fecaca" },
                              }}
                            >
                              <RxReset size={16} />
                            </IconButton>
                          </Tooltip>

                        </div> */}

                      </div>
                      <div className="h-[75%] overflow-y-scroll">
                        {otherServices?.length > 0
                          ? otherServices.map((service) => {
                            return (
                              <div className="flex gap-2 items-center border border-gray-200 py h-6">
                                <div>
                                  <button
                                    className="h-5 "
                                    type="button"
                                    onClick={() => {
                                      handleDeleteOtherService(service);
                                    }}
                                  >
                                    <DeleteOutlineIcon
                                      fontSize="small"
                                      sx={{ color: "red" }}
                                    />
                                  </button>
                                </div>

                                <div className="w-[90%] h-5 flex justify-start px-2  whitespace-nowrap truncate">
                                  {service?.label}
                                </div>
                                {/* <div className="px-4">
                                    {service?.Quantity}
                                  </div> */}
                              </div>
                            );
                          })
                          : ""}
                      </div>
                    </div>
                  </div>

                  <div className=" h-36 shadow-lg shadow-slate-300">
                    <div className=" items-center  h-9 flex justify-between px-2 pt-1 bg-[#F1F1F1]">
                      <div className="text-xs px-1 whitespace-nowrap font-semibold flex gap-2">
                        Diet & Exercise
                      </div>
                      {/* 
                      <div className="w-[65%]" ref={advicesFocusRef}>
                        <CustomCreateable
                          width={"170px"}
                          control={control}
                          name={"searchDietExercise"}
                          placeholder={"Diet & Exercise"}
                          dataArray={dietOptions}
                          handleInputChange={handleSearchDiets}
                          isSearchable={true}
                          showSearch={true}
                          inputRef={{
                            ...register("searchDietExercise", {
                              onChange: (e) => {
                                if (e?.target?.value !== null) {
                                  console.log("eeeeee321", e?.target?.value);

                                  setSelectedDiets((prevData) => [
                                    ...prevData,
                                    {
                                      ...{
                                        id: null,
                                        dietId: e?.target?.value?.id
                                          ? e?.target?.value?.id
                                          : null,
                                        description: e?.target?.value?.label,
                                      },
                                    },
                                  ]);
                                  setValue("searchDietExercise", null);
                                }
                              },
                            }),
                          }}
                        />
                      </div> */}

                      {/* ✅ ICONS ADDED AT END */}
                      <div className="flex gap-1 flex-shrink-0">

                        <Tooltip title="Create">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dcfce7",
                              color: "#166534",
                              "&:hover": { bgcolor: "#bbf7d0" },
                            }}
                            onClick={() => {
                              setTemplateValue(watch("dietExerices") || "")
                              setDietExercise(true)
                              setSelectedFieldId(15)
                            }}
                          >
                            <CiSquarePlus size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Edit">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#dbeafe",
                              color: "#1e3a8a",
                              "&:hover": { bgcolor: "#bfdbfe" },
                            }}
                          >
                            <CiEdit size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Past History">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#ede9fe",
                              color: "#4c1d95",
                              "&:hover": { bgcolor: "#ddd6fe" },
                            }}
                            onClick={getEmrDietAndExrciesePastHistory}
                          >
                            <GoHistory size={16} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Clear">
                          <IconButton
                            sx={{
                              width: 26,
                              height: 26,
                              p: 0.5,
                              bgcolor: "#fee2e2",
                              color: "#7f1d1d",
                              "&:hover": { bgcolor: "#fecaca" },
                            }}
                            onClick={() => {
                              setSelectedDiets([])
                              setValue("dietExerices", "")
                            }}
                          >
                            <RxReset size={16} />
                          </IconButton>
                        </Tooltip>

                      </div>
                    </div>
                    <div className="font-semibold rounded h-[75%] overflow-y-scroll">
                      {/* {selectedDiets?.length > 0
                        ? selectedDiets.map((diet, index) => (
                          <div className="flex gap-2 items-center border border-gray-200 h-6">
                            <div>
                              <button
                                className="h-5 "
                                type="button"
                                onClick={() => {
                                  let tempDiet = [...selectedDiets];
                                  tempDiet?.splice(index, 1);
                                  setSelectedDiets(tempDiet);
                                }}
                              >
                                <DeleteOutlineIcon
                                  fontSize="small"
                                  sx={{ color: "red" }}
                                />
                              </button>
                            </div>

                            <div className="w-[90%] h-5 flex justify-start px-2 font-normal whitespace-nowrap truncate">
                              {diet?.description}
                            </div>
                          </div>
                        ))
                        : ""} */}





                      <InputAreaDropdown
                        // label={"Gen"}
                        minRows={2}
                        control={control}
                        name={"dietExerices"}
                        handleInputChange={(e) => {
                          const tempCheckChar =
                            e !== null
                              ? UseCheckConsecutiveCharacters(e)
                              : true;
                          if (e !== "" && tempCheckChar) {
                            getTemplateSuggetion({
                              fieldId: 15,
                              doctorId: selectedRow?.["Doctor Id"],
                              searchString: e,
                            })
                              .then((response) => {
                                let res = response?.data?.result;
                                console.log(res);
                                setSuggestedData(res);
                              })
                              .catch((error) => {
                                console.log(error);
                              });
                          } else {
                            setSuggestedData([]);
                          }
                        }}
                        error={errors?.hopi}
                        suggestions={suggestedData}
                        onSelectedIdChange={(id) => {
                          setSelectedDietExercises(id);
                        }}
                        onSuggestionSelect={(item) => {
                          console.log("setValuesetValuesetValuesetValue", item);

                          setValue("dietExerices", item.value);
                          // setSelectedId(item.id);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-2 gap-2">

                  <div className="shadow-lg shadow-slate-300 pb-6">
                    <div className="flex gap-1 py-1">
                      {/* <Tooltip title="Create">
                        <IconButton
                          sx={{
                            ...iconButtonStyle,
                            bgcolor: "#dcfce7",
                            color: "#166534",
                            "&:hover": { bgcolor: "#bbf7d0" },
                          }}
                        >
                          <CiSquarePlus size={16} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Edit">
                        <IconButton
                          sx={{
                            ...iconButtonStyle,
                            bgcolor: "#dbeafe",
                            color: "#1e3a8a",
                            "&:hover": { bgcolor: "#bfdbfe" },
                          }}
                        >
                          <CiEdit size={16} />
                        </IconButton>
                      </Tooltip> */}

                      <Tooltip title="Past History">
                        <IconButton
                          sx={{
                            ...iconButtonStyle,
                            bgcolor: "#ede9fe",
                            color: "#4c1d95",
                            "&:hover": { bgcolor: "#ddd6fe" },
                          }}
                          onClick={getEmrReviewOfLab}
                        >
                          <GoHistory size={16} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Clear">
                        <IconButton
                          sx={{
                            ...iconButtonStyle,
                            bgcolor: "#fee2e2",
                            color: "#7f1d1d",
                            "&:hover": { bgcolor: "#fecaca" },
                          }}
                          onClick={() => {
                            setValue("reviewOfLab", "")
                          }}
                        >
                          <RxReset size={16} />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <InputArea
                      control={control}
                      name={"reviewOfLab"}
                      label={"Review Of Lab"}
                      minRows={3}
                    />
                  </div>
                  <div>
                    <div>
                      <div className=" grid items-center shadow-lg shadow-slate-300 p-2 my-2">
                        <div className="flex space-x-1 items-center pt-4">
                          <label className="text-sm font-semibold whitespace-nowrap">
                            Followup After :&nbsp;
                          </label>
                          <div className="w-40">
                            <InputField
                              type="Number"
                              control={control}
                              name="followupAfterDuration"
                              label="Duration"
                              inputRef={{
                                ...register("followupAfterDuration", {
                                  onChange: (e) => {
                                    caclulateFollowupAfterDate(
                                      Number(e.target.value),
                                      new Date(),
                                      followupAfterValue,
                                    );
                                  },
                                }),
                              }}
                            />
                          </div>
                          <div className="flex space-x-1 items-center">
                            {["D", "M"]?.map((val) => (
                              <button
                                type="button"
                                className={`h-6 w-6 rounded-full flex justify-center items-center font-semibold cursor-pointer pt-[1px] ${followupAfterValue === val
                                  ? "bg-[#073763] text-white"
                                  : "border border-slate-600"
                                  }`}
                                onClick={() => {
                                  setFollowupAfterValue(val);
                                  caclulateFollowupAfterDate(
                                    Number(getFollowupAfterDuration),
                                    new Date(),
                                    val,
                                  );
                                }}
                              >
                                {val}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="mt-2">
                          <div className="mt-2">
                            <DatePickerField
                              control={control}
                              name="nextFollowupDate"
                              label="Next Followup Date"
                              inputFormat="dd-MM-yyyy"
                            />

                            {!isFollowupDateValid && (
                              <p className="text-red-600 text-xs mt-1">
                                Follow-up appointments cannot be scheduled on Sundays
                              </p>
                            )}
                          </div>
                        </div>
                        {/* status */}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end col-span-2 pb-6">
                    <div className="flex space-x-2 flex-wrap items-end pb-2 justify-end">
                      <div className="">
                        {/* <CommonButton
                              className={
                                "px-3 h-9 text-[#E3902F] border border-[#E3902F] rounded"
                              }
                              type={"button"}
                              onClick={() => {
                                setIsPreview(true);
                                handlePrintPreview();
                              }}
                              label="Preview"
                            /> */}

                        <CommonButton
                          className={
                            "px-3 h-9 text-[#E3902F] border border-[#E3902F] rounded"
                          }
                          type={"button"}
                          onClick={() => {
                            setOpenPrintModal(true);
                          }}
                          label="Print"
                        />
                      </div>
                      {completeEmr !== true && (
                        <div className="">
                          <CommonButton
                            className={"text-white bg-[#368505] rounded"}
                            type={"button"}
                            label="Complete"
                            onClick={handleSubmit(handleSubmitEmr)}
                          />
                        </div>
                      )}
                      {completeEmr === true && (
                        <div className="">
                          <CommonButton
                            className={" text-white bg-[#368505] rounded"}
                            type={"button"}
                            label="Update"
                            onClick={handleSubmit(handleSubmitEmr)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <CommonBackDrop openBackdrop={openBackdrop} />

            {openPastHistory && (
              <PastHistoryModal
                selectedIndex={selectedHistoryIndex}
                setSelectedIndex={setSelectedHistoryIndex}
                selectedHistory={selectedHistory}
                setSelectedHistory={setSelectedHistory}
                open={openPastHistory}
                close={handleClosePastHistory}
                resetCount={resetCount}
              />
            )}

            {openFamilyHistory && (
              <FamilyHistoryModal
                selectedIndex={selectedFamilyHistoryIndex}
                setSelectedIndex={setSelectedFamilyHistoryIndex}
                selectedFamilyHistory={selectedFamilyHistory}
                setSelectedFamilyHistory={setSelectedFamilyHistory}
                open={openFamilyHistory}
                close={handleCloseFamilyHistory}
              />
            )}
            {openComplaints && (
              <ComplaintsModal
                complaints={complaints}
                setComplaints={setComplaints}
                open={openComplaints}
                close={handleCloseComplaints}
                selectedComplaints={selectedComplaints}
                setSelectedComplaints={setSelectedComplaints}
                resetComplaints={resetComplaints}
              />
            )}
            {openDiagnosis && (
              <DiagnosisModal
                open={openDiagnosis}
                close={handleCloseDiagnosis}
                diagnosisList={diagnosis}
                setDiagnosisList={setDiagnosis}
                selectedDiagnosis={selectedDiagnosis}
                setSelectedDiagnosis={setSelectedDiagnosis}
                location={location}
                resetDiagnosis={resetDiagnosis}
              />
            )}
            {openInvestigation && (
              <InvestigationModal
                open={openInvestigation}
                close={handleCloseInvestigation}
                investigationList={investigationList}
                setInvestigationList={setInvestigationList}
                selectedInvestigations={selectedInvestigations}
                setSelectedInvestigations={setSelectedInvestigations}
                resetInv={resetInv}
                departmentId={location?.state?.departmentId}
              />
            )}
            {openServices && (
              <OtherServicesModal
                open={openServices}
                close={handleCloseServices}
                otherServices={otherServices}
                setOtherServices={setOtherServices}
                resetServices={resetServices}
                departmentId={location?.state?.departmentId}
              />
            )}
            {openAdviceTemplate && (
              <AdviceTemplateModal
                open={openAdviceTemplate}
                close={handleCloseAdviceTemplate}
                adviceTemplates={adviceTemplates}
                setAdviceTemplates={setAdviceTemplates}
              />
            )}
            {openClinical && (
              <ClinicalModal
                open={openClinical}
                close={handleCloseClinical}
                selectedClinical={selectedClinical}
                setSelectedClinical={setSelectedClinical}
              />
            )}
            {openAllergy && (
              <AllergyModal
                open={openAllergy}
                close={handleCloseAllergy}
                selectedAllergy={selectedAllergy}
                setSelectedAllergy={setSelectedAllergy}
                handleDeleteAllergy={handleDeleteAllergy}
              />
            )}

            {openPreview && (
              <PrintOptions
                open={openPreview}
                printObject={printObject}
                close={handleClosePreview}
              />
            )}
            <ConfirmationModal
              confirmationOpen={openPost}
              confirmationHandleClose={handleClosePost}
              confirmationSubmitFunc={
                completeEmr === true ? updateEmr : postEmr
              }
              confirmationLabel="Confirmation "
              confirmationMsg={`Are you sure want to ${completeEmr === true ? `update` : `add`
                } this record ?`}
              confirmationButtonMsg={completeEmr === true ? "Update" : "Save"}
            />
            {/* <CommonBackDrop openBackdrop={openBackdrop} /> */}
            {openOldMedicationsModal && (
              <OldMedicationModal
                openOldMedicationsModal={openOldMedicationsModal}
                setOpenOldMedicationsModal={setOpenOldMedicationsModal}
                oldMedicationsList={oldMedicationsList}
                setOldMedicationsList={setOldMedicationsList}
              />
            )}
            <Modal
              open={startConsultation}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "background.paper",
                  border: "2px solid #848211",
                  borderRadius: "0.5rem",
                  boxShadow: 24,
                  px: 4,
                  pb: 4,
                }}
              >
                <p className="mt-6 tracking-wide font-medium  text-lg ">
                  {"Confirmation"}
                </p>
                <div className=" justify-center align-middle">
                  <p className="my-1 tracking-wide text-lg">
                    {"Do you want to start consultation ?"}
                  </p>
                  <div className="mt-3 flex  justify-center space-x-4">
                    <CommonButton
                      type="button"
                      label="No"
                      onClick={() => {
                        setStartConsultation(false);
                        close();
                      }}
                      className="border border-customRed text-customRed"
                    />
                    <CommonButton
                      type="button"
                      label={"Yes"}
                      onClick={emrConsultation}
                      className="bg-customGreen text-white"
                    />
                  </div>
                </div>
              </Box>
            </Modal>
          </div>
        </Box>
      </Modal>
      {
        openSystemExam && < SystematicExamModal open={openSystemExam} setOpenSystemeticExam={setOpenSystemeticExam} onClose={(templateData) => {
          // 1. Close the modal
          setOpenSystemeticExam(false);

          // 2. If template data exists, patch all fields to the form
          if (templateData) {
            Object.keys(templateData).forEach((fieldKey) => {
              setValue(fieldKey, templateData[fieldKey], {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true
              });
            });
          }
        }} />

      }
      {openGeneralExam && <GeneralExamTemplate templateValue={templateValue}
        openModal={openGeneralExam} setOpenModal={setOpenGeneralExamModal} onClose={setOpenGeneralExamModal} selectedRow={selectedRow} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId} />}
      {openNewSystematicExamTempalte && <NewTemplateModal open={openNewSystematicExamTempalte} setOpenModal={setNewTemplateForSystematicExam} onClose={setNewTemplateForSystematicExam} getRS={getRS}
        getCVS={getCVS}
        getCNS={getCNS}
        getPA={getPA}
        selectedRow={selectedRow}

        getOther={getOther} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId}
        getHopi={getHopi}
        getGeneralExaminations={getGeneralExaminations} selectedId={selectedGeneralExam} />}
      {openModal && (
        <TemplateNameModal
          // selectedId={selectedId}
          openModal={openModal}
          setOpenModal={setOpenModal}
          templateValue={templateValue}

          selectedRow={selectedRow}
          selectedFieldId={selectedFieldId}
          setSelectedFieldId={setSelectedFieldId}
          getHopi={getHopi}
          getGeneralExaminations={getGeneralExaminations}

        />
      )}
      {openAdviceMoal && <AdvicesTemplate setTemplateValue={setTemplateValue} templateValue={templateValue}
        selectedRow={selectedRow} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId} openModal={openAdviceMoal} setOpenModal={setOpenAdviceModal} />}
      {openDietExercise && <DietExerciseModal setTemplateValue={setTemplateValue} templateValue={templateValue} openModal={openDietExercise} setOpenModal={setDietExercise} selectedRow={selectedRow} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId} />}

      {openPastHistoryModal && <PastHistoryTemplateModal setTemplateValue={setTemplateValue} templateValue={templateValue} openModal={openPastHistoryModal} setOpenModal={setOpenPastHistoryModal} selectedRow={selectedRow} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId} />}
      {openFamilyHistoryTempModal && <FamilyHistoryTemplateModal setTemplateValue={setTemplateValue} templateValue={templateValue} openModal={openFamilyHistoryTempModal} setOpenModal={setOpenFamilyHistoryTempModal} selectedRow={selectedRow} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId} />}
      {openComplaintTempModal && <ComplaintsTemplateModal setTemplateValue={setTemplateValue} templateValue={templateValue} openModal={openComplaintTempModal} setOpenModal={setOpenComplaintTempModal} selectedRow={selectedRow} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId} />}
      {openAllergyTemplateModal && <AllergyTemplateModal setTemplateValue={setTemplateValue} templateValue={templateValue} openModal={openAllergyTemplateModal} setOpenModal={setOpenAllergyTemplateModal} selectedRow={selectedRow} selectedFieldId={selectedFieldId} setSelectedFieldId={setSelectedFieldId} />}
      {openLabModal && (
        <EMRInvestigationsModal
          openLabModal={openLabModal}
          setOpenLabModal={setOpenLabModal}
          selectedPatient={selectedRow}
          PatientId={selectedRow?.PatientId}
        />
      )}

      {openPrintModal && renderPrint()}
    </div>
  );
}

export default EmrLiteNew;
